<template>
    <div class="school-detail-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/school' }">查学校</el-breadcrumb-item>
            <el-breadcrumb-item>学校详情</el-breadcrumb-item>
        </el-breadcrumb>
		<el-row class="school-detail-bg">
			<el-row v-if="!schoolInfor.scl_name">
				<ContentLoader primaryColor="rgba(255,255,255,0.1)" secondaryColor="rgba(255,255,255,0.05)" :base-url="$route.fullPath" height="150" width="1000" viewBox="0 0 1000 150">
					<rect x="150" y="20" width="117" height="30" />
					<rect x="150" y="70" width="140" height="25" />
					<circle cx="60" cy="60" r="55" />
				</ContentLoader>
			</el-row>
			<el-row v-else>
				<el-col :span="3">
					<el-row class="school-logo">
						<img :src="schoolInfor.logo" alt="学校logo" ref="schoolImg" @error="nofindImg()">
						<transition v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter">
						<div v-if="showImage">
							<img class="active-img-inner active-img-inner-hook" :src="schoolInfor.logo" alt="大学logo">
						</div>
					</transition>
					</el-row>
				</el-col>
				<el-col :span="14">
					<div class="zytb-school-name">
						{{schoolInfor.scl_name}}<img src="../../assets/images/wz1.png" alt="位置">
						<span v-if="schoolInfor.city_name">{{schoolInfor.province_name.indexOf('北京') != -1 || schoolInfor.province_name.indexOf('天津') != -1 || schoolInfor.province_name.indexOf('上海') != -1 || schoolInfor.province_name.indexOf('重庆') != -1 ? '' : schoolInfor.province_name}}{{schoolInfor.city_name}}</span>
					</div>
					<div class="zytb-school-tag">
						<span v-if="schoolInfor.school_type">{{schoolInfor.school_type}}</span>
						<span v-if="schoolInfor.school_nature">{{schoolInfor.school_nature}}</span>
						<span v-if="schoolInfor.school_nature_type">{{schoolInfor.school_nature_type}}</span>
						<span v-if="schoolInfor.f211 == '1'">211</span>
						<span v-if="schoolInfor.f985 == '1'">985</span>
						<span v-if="schoolInfor.dual_class != '38003' && schoolInfor.dual_class">双一流</span>
						<span v-if="schoolInfor.is_provincial == '1'">省重点</span>
						<span v-if="schoolInfor.is_doublehigh == '77'">双高计划</span>
					</div>
				</el-col>
				<el-col :span="7" style="width: 27.6%">
					<el-button class="school-compare" v-if="!isPk" @click.native="addCompare" v-click-with-auth-login>
						<img src="../../assets/images/add_white.png" alt="加入对比">
						加入对比
					</el-button>
					<el-button class="school-compare-diff" v-else @click="removeCompare">
						<img src="../../assets/images/remove_white.png" alt="取消对比">
						取消对比
					</el-button>
					<el-button class="school-compare" v-if="fav_value < 0.00" v-click-with-auth-login @click="favDetail">
						<img src="../../assets/images/fav_icon1.png" alt="设为心仪" class="fav-img1">
						设为心仪
					</el-button>
					<el-button v-else class="school-compare-diff" @click="favDetail">
						<el-rate
							v-model="fav_value"
							disabled
							:max="1"
							:show-score="false"
							disabled-void-color="#ffcab3"
							score-template="{fav_value}">
						</el-rate>
						{{ fav_value === 0.99 ? '心仪院校': '心仪详情' }}
					</el-button>
				</el-col>
			</el-row>
		</el-row>
		<el-row style="margin-top:-46px;">
			<template>
				<el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="beforeLeave" class="school-detail-nav" :class="scrollTag?'fixed-top':''">
					<el-tab-pane label="学校概况" name="first">
						<el-row>
							<el-col :span="16" style="padding-right: 16px;width:67.5%">
								<div class="school-detail-common school-detail-fg school-detail-common-diff1">
									<el-row v-if="imageList.length > 0">
										<el-col :span="18">
											<div :style="{backgroundImage:'url(' + baseUrl + activeImgSrc.pic_url + ')'}" class="active-img-box"></div>
										</el-col>
										<el-col :span="6">
											<!-- <img src="../../assets/images/jtsb.png" alt="上一张" class="school-detail-jts" v-if="activeImg == 0">
											<img :src='prevImg' alt="上一张" class="school-detail-jts" v-else @mouseover="hoverPrevImgHandler" @mouseout="prevImgHandler" @click="clickPrevImgHandler"> -->
											<div class="school-small-img" v-for="(item,index) in showImgList" :key="index" :class="activeImg==index?'active-img':''">
												<el-image :src="baseUrl + item.pic_url" fit="fill" @click="changeImgSrcHandler(index)"></el-image>
											</div>
											<!-- <img src="../../assets/images/jtxb.png" alt="下一张" class="school-detail-jtx" v-if="activeImg==(imageList.length-1)">
											<img :src="nextImg" alt="上一张" class="school-detail-jtx" v-else @mouseover="hoverNextImgHandler" @mouseout="nextImgHandler" @click="clickNextImgHandler"> -->
										</el-col>
									</el-row>
									<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200"  v-if="!searchSchoolStatus1">
										<rect x="0" y="10" width="1100" height="180" />
									</ContentLoader>
									<el-row v-else>
										<div class="no-data-box" v-if="!schoolInfor.scl_desc && imageList.length==0">
											<img src="../../assets/images/null.png" alt="没有数据">
											<p>暂无数据</p>
										</div>
										<el-row class="school-detail-content" v-else>
											<div v-if="schoolInfor.scl_desc">
												<div class="school-detail-js" :class="{'school-detail-js-more':showAllContent}" v-html="schoolInfor.scl_desc">
												</div>
												<div class="choice-box" @click="showAllhandler" v-if="!showAllContent">查看全部<i class="el-icon-arrow-down"></i></div>
												<div class="choice-box" @click="showAllhandler" v-else>收起<i class="el-icon-arrow-up"></i></div>
											</div>
										</el-row>
									</el-row>
								</div>
								<div class="school-detail-common school-detail-zy school-detail-table-diff1">
									<el-row type="flex" justify="space-between">
										<h3>开设专业</h3>
										<!-- <el-button @click="showAllMajorHandler" v-if="majorInfor.length > 0">查看全部<i class="el-icon-arrow-right"></i></el-button> -->
									</el-row>
									<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSchoolStatus1">
										<rect x="0" y="10" width="1100" height="180" />
									</ContentLoader>
									<el-row v-else>
										<el-table
										:data="majorInfor"
										style="width: 100%" border>
											<el-table-column label="专业分类" width="261">
												<template slot-scope="scope">
													<a> {{scope.row.subject_type_name}}</a>
												</template>
											</el-table-column>
											<el-table-column label="专业" width="472">
												<template slot-scope="scope">
													<span v-for="(item,index) in scope.row.special_name" :key="index" @click="showMajorDetailHandler(scope.row,index)">{{item}}</span>
												</template>
											</el-table-column>
										</el-table>
										<tr v-if="majorInfor.length > 0" class="el-table__row" style="line-height: 48px">
											<td style="width:261px;padding-left: 30px">
												<div class="cell"><a> 哲学类(本)</a></div>
											</td>
											<td style="width:472px">
												<div class="cell"><span>学</span></div>
											</td>
										</tr>
										<el-row class="school-detail-all" @click.native="showAllMajorHandler" v-if="majorInfor.length > 0"><span>查看全部<i class="el-icon-arrow-right"></i></span></el-row>
									</el-row>
								</div>
								<div v-if="provinceCode !== '13'" class="school-detail-common school-detail-fs school-detail-table-diff1">
									<el-row type="flex" justify="space-between">
										<h3>历年分数</h3>
										<!-- <el-button @click="showAllScoreHandler" v-if="scoreLineInfor.length > 0">查看全部<i class="el-icon-arrow-right"></i></el-button> -->
									</el-row>
									<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSchoolStatus1">
										<rect x="0" y="10" width="1100" height="180" />
									</ContentLoader>
									<el-row v-else>
										<el-table :data="scoreLineInforArr" style="width: 100%" border>
											<el-table-column prop="year" label="年份" width="95">
											</el-table-column>
											<el-table-column label="院校代码" width="130">
												<template slot-scope="scope">
													{{scope.row.scl_code?scope.row.scl_code:'-'}}
													{{scope.row.zslx_name?'('+scope.row.zslx_name+')':''}}
												</template>
											</el-table-column>
											<el-table-column label="批次" width="144">
												<template slot-scope="scope">
													{{batchListObj[scope.row.local_batch_id]}}
												</template>
											</el-table-column>
											<el-table-column label="投档分" width="125">
												<template slot-scope="scope">
													{{scope.row.score_min?scope.row.score_min:'-'}}
												</template>
											</el-table-column>
											<el-table-column label="投档分位次" width="125">
												<template slot-scope="scope">
													{{scope.row.min_section?scope.row.min_section:'-'}}
												</template>
											</el-table-column>
											<el-table-column label="录取数" width="114">
												<template slot-scope="scope">
													{{scope.row.real_count?scope.row.real_count:'-'}}
												</template>
											</el-table-column>
										</el-table>
										<tr class="el-table__row" style="line-height: 48px" v-if="scoreLineInforArr.length > 0">
											<td style="width:65px;padding-left: 30px">
												<div class="cell">2021</div>
											</td>
											<td style="width:144px;padding-left: 30px">
												<div class="cell">本科一批</div>
											</td>
											<td style="width:150px;padding-left: 30px">
												<div class="cell">普通类</div>
											</td>
											<td style="width:186px;padding-left: 30px">
												<div class="cell">697/111</div>
											</td>
											<td style="width:158px;padding-left: 30px">
												<div class="cell">518/</div>
												</td>
											</tr>
										<el-row class="school-detail-all" @click.native="showAllScoreHandler" v-if="scoreLineInforArr.length > 0" v-click-with-auth-login><span>查看全部<i class="el-icon-arrow-right"></i></span></el-row>
									</el-row>
								</div>
							</el-col>
							<el-col :span="8" style="width:32.5%">
								<div class="school-detail-common">
									<h3>学校信息</h3>
									<div class="school-detail-gw">
										<div class="school-detail-gw-title"><img src="../../assets/images/gw.png" alt="官方网站">官方网址：</div>
										<a :href="schoolInfor.school_site" v-if="schoolInfor.school_site" target="_blank" class="school-detail-gw-title-diff">{{schoolInfor.school_site}}</a>
										<div v-else>-</div>
									</div>
									<div class="school-detail-gw">
										<div class="school-detail-gw-title"><img src="../../assets/images/dh.png" alt="官方电话">官方电话：</div>
										<div>{{schoolInfor.phone ? schoolInfor.phone : '-'}}</div>
									</div>
									<div class="school-detail-gw">
										<div class="school-detail-gw-title"><img src="../../assets/images/yx.png" alt="电子邮箱">电子邮箱：</div>
										<div>{{schoolInfor.email ? schoolInfor.email : '-'}}</div>
									</div>
								</div>
								<div class="school-detail-common school-detail-xx">
									<h3>基本信息</h3>
									<el-row>
										<el-col :span="24">
											<div class="grid-content school-detail-blue">
												<el-row class="school-detail-xl">
													博士点
												</el-row>
												<el-row class="school-detail-sl">
													<el-col :span="12">
														<div>
															<span class="school-detail-count" v-if="schoolInfor.num_doctor >= 0">{{schoolInfor.num_doctor}}</span>
															<span class="school-detail-count school-count-zero" v-else>--</span>
														个</div>
														<div class="school-detail-yj">一级</div>
													</el-col>
													<el-col :span="12">
														<div>
															<span class="school-detail-count" v-if="schoolInfor.num_doctor2 >= 0">{{schoolInfor.num_doctor2}}</span>
															<span class="school-detail-count school-count-zero" v-else>--</span>
														个</div>
														<div class="school-detail-yj">二级</div>
													</el-col>
												</el-row>
											</div>
										</el-col>
										<el-col :span="24">
											<div class="grid-content school-detail-green">
												<el-row class="school-detail-xl">
													硕士点
												</el-row>
												<el-row class="school-detail-sl">
													<el-col :span="12">
														<div>
															<span class="school-detail-count" v-if="schoolInfor.num_master >= 0">{{schoolInfor.num_master}}</span>
															<span class="school-detail-count school-count-zero" v-else>--</span>
														个</div>
														<div class="school-detail-yj">一级</div>
													</el-col>
													<el-col :span="12">
														<div>
															<span class="school-detail-count" v-if="schoolInfor.num_master2 >= 0">{{schoolInfor.num_master2}}</span>
															<span class="school-detail-count school-count-zero" v-else>--</span>
														个</div>
														<div class="school-detail-yj">二级</div>
													</el-col>
												</el-row>
											</div>
										</el-col>
										<el-col :span="24">
											<div class="grid-content school-detail-red">
												<el-row class="school-detail-xl">
													国家重点
												</el-row>
												<el-row class="school-detail-sl">
													<el-col :span="12">
														<div>
															<span class="school-detail-count" v-if="schoolInfor.num_subject >= 0">{{schoolInfor.num_subject}}</span>
															<span class="school-detail-count school-count-zero" v-else>--</span>
														个</div>
														<div class="school-detail-yj">重点学科</div>
													</el-col>
													<el-col :span="12">
														<div>
															<span class="school-detail-count" v-if="schoolInfor.num_lab >= 0">{{schoolInfor.num_lab}}</span>
															<span class="school-detail-count school-count-zero" v-else>--</span>
														个</div>
														<div class="school-detail-yj">重点实验室</div>
													</el-col>
												</el-row>
											</div>
										</el-col>
									</el-row>
								</div>
								<div class="school-detail-common school-detail-kx">
									<el-row type="flex" justify="space-between">
										<h3>招生快讯</h3>
										<el-button @click="showAllNewsHandler" v-if="totalData != 0">查看全部<i class="el-icon-arrow-right"></i></el-button>
									</el-row>
									<div v-if="!searchSchoolStatus1">
										<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="40" width="400" viewBox="0 0 1000 40" v-for="item in 6" :key="item">
											<rect x="0" y="0" width="220" height="22" />
											<rect x="336" y="0" width="80" height="22" />
										</ContentLoader>
									</div>
									<div v-else>
										<div class="no-data-box" v-if="totalData == 0">
											<img src="../../assets/images/null.png" alt="没有数据">
											<p>暂无数据</p>
										</div>
										<el-row type="flex" justify="space-between" class="school-detail-zs" v-for="(item,index) in newsList" :key="index" @click.native="linkNewsHandler(item.id)" v-else>
											<el-col :span="18">{{item.title}}</el-col>
											<el-col :span="6">{{item.create_time|dateHandler}}</el-col>
										</el-row>
									</div>
								</div>
							</el-col>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="开设专业" name="second">
						<div class="school-detail-common school-detail-zy">
							<h3>开设专业</h3>
							<el-table
							:data="majorInforAll"
							style="width: 100%" border>
								<el-table-column label="专业分类" width="330">
									<template slot-scope="scope">
										<a> {{scope.row.subject_type_name}}</a>
									</template>
								</el-table-column>
								<el-table-column label="专业" width="804">
									<template slot-scope="scope">
										<span v-for="(item,index) in scope.row.special_name" :key="index" @click="showMajorDetailHandler(scope.row,index)">{{item}}</span>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-tab-pane>
					<el-tab-pane label="历年分数" name="third">
						<div v-if="provinceCode !== '13'" class="school-detail-common school-detail-fs school-detail-ln">
							<h3>历年分数</h3>
							<el-row>
								<el-col :span="2">
									科目类型：
								</el-col>
								<el-col :span="2" class="header-link" @mouseenter.native="linkShowState('true')" @mouseleave.native="linkShowState('false')">
									<a v-if="subjectDefault">{{subjectDefault.name}}<i class="el-icon-arrow-down el-icon--right" v-if="linkShow=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="linkShow=='true'"></i></a>
									<el-menu v-show="linkShow=='true'">
										<li v-for="(item,index) in subjectList" :key="index" @click="changeYearHandler(index)">{{item.name}}</li>
									</el-menu>
								</el-col>
							</el-row>
							<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSchoolStatus1 && !noRequestStatus3">
								<rect x="0" y="20" width="1100" height="180" />
							</ContentLoader>
							<el-row v-else>
								<el-table :data="scoreLineInfor" style="width: 100%" border>
									<el-table-column prop="year" label="年份" width="120">
									</el-table-column>
									<el-table-column label="院校代码" width="206">
										<template slot-scope="scope">
											{{scope.row.scl_code?scope.row.scl_code:'-'}}
											{{scope.row.zslx_name?'('+scope.row.zslx_name+')':''}}
										</template>
									</el-table-column>
									<el-table-column label="批次" width="277">
										<template slot-scope="scope">
											{{batchListObj[scope.row.local_batch_id]}}
										</template>
									</el-table-column>
									<el-table-column label="投档分" width="150">
										<template slot-scope="scope">
											{{scope.row.score_min?scope.row.score_min:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="投档分位次" width="200">
										<template slot-scope="scope">
											{{scope.row.min_section?scope.row.min_section:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="录取数" width="180">
										<template slot-scope="scope">
											{{scope.row.real_count?scope.row.real_count:'-'}}
										</template>
									</el-table-column>
								</el-table>
								<el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="lineTotal" :page-size="20" @current-change="getSchoolScoreLineHandler" v-if="lineTotal > 0" :current-page.sync="currentLinePage">
								</el-pagination>
							</el-row>
						</div>
						<div v-if="has_code == 1" class="school-detail-common school-detail-fs school-detail-ln">
							<h3>专业录取分数</h3>
							<el-row>
								<el-col :span="2">
									科目类型：
								</el-col>
								<el-col :span="2" class="header-link" @mouseenter.native="linkShowState2('true')" @mouseleave.native="linkShowState2('false')">
									<a v-if="subjectDefault2">{{subjectDefault2.name}}<i class="el-icon-arrow-down el-icon--right" v-if="linkShow2=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="linkShow2=='true'"></i></a>
									<el-menu v-show="linkShow2=='true'">
										<li v-for="(item,index) in subjectList2" :key="index" @click="changeYearHandler2(index)">{{item.name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="2">
									年份：
								</el-col>
								<el-col v-if="lineDefault" :span="2" class="header-link header-link-diff1" @mouseenter.native="yearLinkShowState1('true')" @mouseleave.native="yearLinkShowState1('false')">
									<a>{{lineDefault.year}}<i class="el-icon-arrow-down el-icon--right" v-if="yearLinkShow1=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="yearLinkShow1=='true'"></i></a>
									<el-menu v-show="yearLinkShow1=='true'" class="header-link-menu">
										<li v-for="(item,index) in yearLineList" :key="index" @click="changeLineYearHandler(index)">{{item}}</li>
									</el-menu>
								</el-col>
								<el-col :span="2" v-else class="header-link header-link-diff1">--</el-col>
								<el-col :span="2">
									批次：
								</el-col>
								<el-col :span="4"  v-if="batchDefault1" class="header-link header-link-diff2" @mouseenter.native="batchLinkShowState1('true')" @mouseleave.native="batchLinkShowState1('false')">
									<a @click="batchLinkShowState1">{{batchDefault1.name}}<i class="el-icon-arrow-down el-icon--right" v-if="batchLinkShow1=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="batchLinkShow1=='true'"></i></a>
									<el-menu v-show="batchLinkShow1=='true'" class="batch-list-menu">
										<li v-for="(item,index) in batchList1" :key="index" @click="changeBatchHandler1(index)">{{item.name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="4" v-else class="header-link-diff2">--</el-col>
							</el-row>
							<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSchoolStatus1 && !noRequestStatus2">
								<rect x="0" y="20" width="1100" height="180" />
							</ContentLoader>
							<el-row v-else>
								<div style="font-size: 13px;color: #ff933d;margin-top: 16px">{{ lineDesc }}</div>
								<el-table :data="lineInfor" style="width: 100%" border>
									<el-table-column prop="college_code" label="院校代码" min-width="110">
										<template slot-scope="scope">
											{{scope.row.college_code?scope.row.college_code:'-'}}
											{{scope.row.zslx_name?'('+scope.row.zslx_name+')':''}}
										</template>
									</el-table-column>
									<el-table-column label="专业代码" min-width="110">
										<template slot-scope="scope">
											{{scope.row.plan_code?scope.row.plan_code:'-'}}
										</template>
									</el-table-column>
									<el-table-column prop="spname" label="专业名称" min-width="110">
									</el-table-column>
									<el-table-column label="专业详情" min-width="235">
										<template slot-scope="scope">
											{{scope.row.sp_remark?scope.row.sp_remark:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="批次" width="125">
										<template slot-scope="scope">
											{{batchListObj[scope.row.local_batch_id]}}
										</template>
									</el-table-column>
									<el-table-column prop="sp_average" label="平均分" width="90">
									</el-table-column>
									<el-table-column label="最低调档线" width="122">
										<template slot-scope="scope">
											{{scope.row.sp_min?scope.row.sp_min:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="最低位次" width="110">
										<template slot-scope="scope">
											{{scope.row.sp_min_section?scope.row.sp_min_section:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="录取人数" width="110">
										<template slot-scope="scope">
											{{scope.row.sp_num?scope.row.sp_num:'-'}}
										</template>
									</el-table-column>
								</el-table>
								<el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="specialTotal" :page-size="20" @current-change="getSchoolSpecialLineHandler" v-if="specialTotal > 0" :current-page.sync="currentSpecialPage">
								</el-pagination>
							</el-row>
						</div>
					</el-tab-pane>
					<el-tab-pane label="招生计划" name="fourth">
						<div class="school-detail-common school-detail-fs school-detail-ln">
							<h3>招生计划</h3>
							<el-row>
								<el-col :span="2">
									科目类型：
								</el-col>
								<el-col :span="2" class="header-link" @mouseenter.native="linkShowState1('true')" @mouseleave.native="linkShowState1('false')">
									<a v-if="subjectDefault1">{{subjectDefault1.name}}<i class="el-icon-arrow-down el-icon--right" v-if="linkShow1=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="linkShow1=='true'"></i></a>
									<el-menu v-show="linkShow1=='true'">
										<li v-for="(item,index) in subjectList1" :key="index" @click="changeYearHandler1(index)">{{item.name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="2">
									年份：
								</el-col>
								<el-col :span="2" v-if="planDefault" class="header-link header-link-diff1" @mouseenter.native="yearLinkShowState('true')" @mouseleave.native="yearLinkShowState('false')">
									<a>{{planDefault.year}}<i class="el-icon-arrow-down el-icon--right" v-if="yearLinkShow=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="yearLinkShow=='true'"></i></a>
									<el-menu v-show="yearLinkShow=='true'" class="header-link-menu">
										<li v-for="(item,index) in yearPlanList" :key="index" @click="changePlanYearHandler(index)">{{item}}</li>
									</el-menu>
								</el-col>
								<el-col :span="2" v-else class="header-link header-link-diff1">--</el-col>
								<el-col :span="2">
									批次：
								</el-col>
								<el-col :span="4" v-if="batchDefault" class="header-link header-link-diff2" @mouseenter.native="batchLinkShowState('true')" @mouseleave.native="batchLinkShowState('false')">
									<a>{{batchDefault.name}}<i class="el-icon-arrow-down el-icon--right" v-if="batchLinkShow=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="batchLinkShow=='true'"></i></a>
									<el-menu v-show="batchLinkShow=='true'" class="batch-list-menu">
										<li v-for="(item,index) in batchList" :key="index" @click="changeBatchHandler(index)">{{item.name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="4" v-else class="header-link header-link-diff2">--</el-col>
							</el-row>
							<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSchoolStatus1 && !noRequestStatus1">
								<rect x="0" y="20" width="1100" height="180" />
							</ContentLoader>
							<el-row v-else>
								<el-table :data="planInfor" style="width: 100%" border>
									<el-table-column prop="college_code" label="院校代码" min-width="110">
										<template slot-scope="scope">
											{{scope.row.college_code?scope.row.college_code:'-'}}
											{{scope.row.zslx_name?'('+scope.row.zslx_name+')':''}}
										</template>
									</el-table-column>
									<el-table-column label="专业代码" min-width="110">
										<template slot-scope="scope">
											{{scope.row.plan_code?scope.row.plan_code:'-'}}
										</template>
									</el-table-column>
									<el-table-column prop="spname" label="专业名称" min-width="110">
									</el-table-column>
									<el-table-column label="专业详情" min-width="265">
										<template slot-scope="scope">
											{{scope.row.sp_remark?scope.row.sp_remark:''}}{{!scope.row.sp_remark && scope.row.sp_length?'学制：' + scope.row.sp_length + '年':''}}{{!scope.row.sp_remark && scope.row.tuition?'学费：' + scope.row.tuition + '元/年':''}}
											<!-- {{scope.row.sp_remark?scope.row.sp_remark:''}} -->
										</template>
									</el-table-column>
									<el-table-column prop="batch" label="批次" width="125">
										<template slot-scope="scope">
											{{batchListObj[scope.row.local_batch_id]}}
										</template>
									</el-table-column>
									<el-table-column label="计划类型" width="110">
										<template slot-scope="scope">
											{{scope.row.plan_type?scope.row.plan_type:'非定向'}}
										</template>
									</el-table-column>
									<el-table-column prop="sp_num" label="计划招生" width="110">
									</el-table-column>
									<el-table-column label="学制" width="90">
										<template slot-scope="scope">
											{{scope.row.sp_length?scope.row.sp_length:'-'}}
										</template>
									</el-table-column>
									<el-table-column prop="tuition" label="学费" width="90">
									</el-table-column>
								</el-table>
								<el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="planTotal" :page-size="20" @current-change="getSchoolStuPlanHandler" v-if="planTotal > 0" :current-page.sync="currentPlanPage">
								</el-pagination>
							</el-row>
						</div>
					</el-tab-pane>
					<el-tab-pane label="招生快讯" name="fifth">
						<div class="school-detail-common school-detail-kx">
							<h3>招生快讯</h3>
							<div v-if="!searchSchoolStatus1">
								<ContentLoader v-for="item in 20" :key="item" primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="50" width="1100" viewBox="0 0 1000 50">
									<rect x="0" y="10" width="170" height="25" />
									<rect x="1000" y="10" width="110" height="25" />
								</ContentLoader>
							</div>
							<div v-else>
								<div class="no-data-box" v-if="totalData == 0">
									<img src="../../assets/images/null.png" alt="没有数据">
									<p>暂无数据</p>
								</div>
								<el-row type="flex" justify="space-between" class="school-detail-zs" v-for="(item,index) in newsList" :key="index" @click.native="linkNewsHandler(item.id)" v-else>
									<el-col :span="22">{{item.title}}</el-col>
									<el-col :span="2">{{item.create_time|dateHandler}}</el-col>
								</el-row>
								<el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="totalData" :page-size="20" @current-change="getNewsListHandler" v-if="totalData > 0" :current-page.sync="currentPage">
								</el-pagination>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="高职单招" name="sexth" v-if="schoolInfor.single_id">
						<div class="school-detail-common school-detail-fs school-detail-ln">
							<h3>单招专业</h3>
							<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSingleStatus1 && !noSingleRequestStatus1">
								<rect x="0" y="20" width="1100" height="180" />
							</ContentLoader>
							<el-row v-else>
								<div class="no-data-box" v-if="singleList.length == 0">
									<img src="../../assets/images/null.png" alt="没有数据">
									<p>暂无数据</p>
								</div>
								<el-row class="single-special-table" v-else>
									<el-col :span="6" v-for="(item,index) in singleList" :key="index" :title="item.special_name" @click.native="linkSingleDetailHandler(item.scl_special_id)">{{item.special_name}}</el-col>
								</el-row>
							</el-row>
						</div>
						<div class="school-detail-common school-detail-fs school-detail-ln">
							<h3>招生计划</h3>
							<el-row>
								<el-col :span="2">
									年份：
								</el-col>
								<el-col :span="2" v-if="singleYearDefault" class="header-link header-link-diff1" @mouseenter.native="singleYearLinkShowState('true')" @mouseleave.native="singleYearLinkShowState('false')">
									<a>{{singleYearDefault}}<i class="el-icon-arrow-down el-icon--right" v-if="singleYearLinkShow=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="singleYearLinkShow=='true'"></i></a>
									<el-menu v-show="singleYearLinkShow=='true'" class="header-link-menu">
										<li v-for="(item,index) in singleSelect.year" :key="index" @click="changeSingleYearHandler(index)">{{item}}</li>
									</el-menu>
								</el-col>
								<el-col :span="2" v-else class="header-link header-link-diff1">--</el-col>
								<el-col :span="2">
									类型：
								</el-col>
								<el-col :span="4" v-if="singleSubjectDefault" class="header-link header-link-diff2" @mouseenter.native="singleSubjectLinkShowState('true')" @mouseleave.native="singleSubjectLinkShowState('false')">
									<a>{{singleSubjectDefault.single_name}}<i class="el-icon-arrow-down el-icon--right" v-if="singleSubjectLinkShow=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="singleSubjectLinkShow=='true'"></i></a>
									<el-menu v-show="singleSubjectLinkShow=='true'">
										<li v-for="(item,index) in singleSubjectList" :key="index" @click="changeSingleSubjectHandler(index)">{{item.single_name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="4" v-else class="header-link header-link-diff2">--</el-col>
								<el-col :span="2">
									对象：
								</el-col>
								<el-col :span="4" v-if="singleStudentDefault" class="header-link header-link-diff2" @mouseenter.native="singleStudentLinkShowState('true')" @mouseleave.native="singleStudentLinkShowState('false')">
									<a>{{singleStudentDefault.single_name}}<i class="el-icon-arrow-down el-icon--right" v-if="singleStudentLinkShow=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="singleStudentLinkShow=='true'"></i></a>
									<el-menu v-show="singleStudentLinkShow=='true'" class="batch-list-menu">
										<li v-for="(item,index) in singleStudentList" :key="index" @click="changeSingleStudentHandler(index)">{{item.single_name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="4" v-else class="header-link header-link-diff2">--</el-col>
							</el-row>
							<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSingleStatus2 && !noSingleRequestStatus2">
								<rect x="0" y="20" width="1100" height="180" />
							</ContentLoader>
							<el-row v-else>
								<el-table :data="singlePlanInfor" style="width: 100%" border>
									<el-table-column prop="spname" label="专业名称" min-width="336">
									</el-table-column>
									<el-table-column prop="num" label="计划招生(人)" min-width="162">
									</el-table-column>
									<el-table-column prop="length" label="学制" min-width="150">
									</el-table-column>
									<el-table-column prop="tuition" label="学费(元)" min-width="153">
									</el-table-column>
									<el-table-column prop="" label="备注" width="330">
										<template>
											<div>--</div>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="singlePlanTotal" :page-size="20" @current-change="getSinglePlanHandler" v-if="singlePlanTotal > 0" :current-page.sync="currentSinglePlanPage">
								</el-pagination>
							</el-row>
						</div>
						<div class="school-detail-common school-detail-fs school-detail-ln">
							<h3>录取分数线</h3>
							<el-row>
								<el-col :span="2">
									年份：
								</el-col>
								<el-col :span="2" v-if="singleYearDefault1" class="header-link header-link-diff1" @mouseenter.native="singleYearLinkShowState1('true')" @mouseleave.native="singleYearLinkShowState1('false')">
									<a>{{singleYearDefault1}}<i class="el-icon-arrow-down el-icon--right" v-if="singleYearLinkShow1=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="singleYearLinkShow1=='true'"></i></a>
									<el-menu v-show="singleYearLinkShow1=='true'" class="header-link-menu">
										<li v-for="(item,index) in singleSelect1.year" :key="index" @click="changeSingleYearHandler1(index)">{{item}}</li>
									</el-menu>
								</el-col>
								<el-col :span="2" v-else class="header-link header-link-diff1">--</el-col>
								<el-col :span="2">
									类型：
								</el-col>
								<el-col :span="4" v-if="singleSubjectDefault1" class="header-link header-link-diff2" @mouseenter.native="singleSubjectLinkShowState1('true')" @mouseleave.native="singleSubjectLinkShowState1('false')">
									<a>{{singleSubjectDefault1.single_name}}<i class="el-icon-arrow-down el-icon--right" v-if="singleSubjectLinkShow1=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="singleSubjectLinkShow1=='true'"></i></a>
									<el-menu v-show="singleSubjectLinkShow1=='true'">
										<li v-for="(item,index) in singleSubjectList1" :key="index" @click="changeSingleSubjectHandler1(index)">{{item.single_name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="4" v-else class="header-link header-link-diff2">--</el-col>
								<el-col :span="2">
									对象：
								</el-col>
								<el-col :span="4" v-if="singleStudentDefault1" class="header-link header-link-diff2" @mouseenter.native="singleStudentLinkShowState1('true')" @mouseleave.native="singleStudentLinkShowState1('false')">
									<a>{{singleStudentDefault1.single_name}}<i class="el-icon-arrow-down el-icon--right" v-if="singleStudentLinkShow1=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="singleStudentLinkShow1=='true'"></i></a>
									<el-menu v-show="singleStudentLinkShow1=='true'" class="batch-list-menu">
										<li v-for="(item,index) in singleStudentList1" :key="index" @click="changeSingleStudentHandler1(index)">{{item.single_name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="4" v-else class="header-link header-link-diff2">--</el-col>
							</el-row>
							<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSingleStatus3 && !noSingleRequestStatus3">
								<rect x="0" y="20" width="1100" height="180" />
							</ContentLoader>
							<el-row v-else>
								<el-table :data="singleLineInfor" style="width: 100%" border>
									<el-table-column prop="spname" label="专业名称" min-width="336">
									</el-table-column>
									<el-table-column prop="num" label="录取人数(人)" min-width="231">
									</el-table-column>
									<el-table-column label="最低调档线" min-width="235">
										<template slot-scope="scope">
											{{scope.row.min}}
										</template>
									</el-table-column>
									<el-table-column label="备注" width="330">
										<template>
											--
										</template>
									</el-table-column>
								</el-table>
								<el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="singleLineTotal" :page-size="20" @current-change="getSingleLineHandler" v-if="singleLineTotal > 0" :current-page.sync="currentSingleLinePage">
								</el-pagination>
							</el-row>
						</div>
						<div class="school-detail-common school-detail-kx">
							<h3>招生快讯</h3>
							<div v-if="!searchSingleStatus4 && !noSingleRequestStatus4">
								<ContentLoader v-for="item in 20" :key="item" primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="50" width="1100" viewBox="0 0 1000 50">
									<rect x="0" y="10" width="170" height="25" />
									<rect x="1000" y="10" width="110" height="25" />
								</ContentLoader>
							</div>
							<div v-else>
								<div class="no-data-box" v-if="totalSingleData == 0">
									<img src="../../assets/images/null.png" alt="没有数据">
									<p>暂无数据</p>
								</div>
								<el-row type="flex" justify="space-between" class="school-detail-zs" v-for="(item,index) in newsSingleList" :key="index" @click.native="linkSingleNewsHandler(item.id)" v-else>
									<el-col :span="22">{{item.title}}</el-col>
									<el-col :span="2">{{item.times.split(' ')[0]}}</el-col>
								</el-row>
								<el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="totalSingleData"  :page-size="20" @current-change="getSingleNewsHandler" v-if="totalSingleData > 0" :current-page.sync="currentSinglePage">
								</el-pagination>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="专升本" name="seventh" v-if="schoolInfor.has_transfer && has_code == 1">
						<div class="school-detail-common school-detail-fs school-detail-ln">
							<h3>录取专业</h3>
							<el-row>
								<el-col :span="2">
									年份：
								</el-col>
								<el-col v-if="specialYearDefault" :span="2" class="header-link header-link-diff1" @mouseenter.native="specialYearLinkShowState1('true')" @mouseleave.native="specialYearLinkShowState1('false')">
									<a>{{specialYearDefault}}<i class="el-icon-arrow-down el-icon--right" v-if="yearSpecialShow1=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="yearSpecialShow1=='true'"></i></a>
									<el-menu v-show="yearSpecialShow1=='true'" class="header-link-menu">
										<li v-for="(item,index) in specialYearList" :key="index" @click="changeSpecialYearHandler(index)">{{item}}</li>
									</el-menu>
								</el-col>
							</el-row>
							<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSpecialStatus1 && !noSpecialRequestStatus1">
								<rect x="0" y="20" width="1100" height="180" />
							</ContentLoader>
							<el-row v-else>
								<el-table :data="specialInfor" style="width: 100%" border>
									<el-table-column prop="spname" label="专业名称" min-width="236">
									</el-table-column>
									<el-table-column prop="spec_code" label="专业代码" min-width="115">
										<template slot-scope="scope">
											<div>{{scope.row.spec_code?scope.row.spec_code: '--'}}</div>
										</template>
									</el-table-column>
									<el-table-column label="学制" min-width="150">
										<template slot-scope="scope">
											<div>{{scope.row.sp_length?scope.row.sp_length: '--'}}</div>
										</template>
									</el-table-column>
									<el-table-column label="是否为师范类" min-width="150">
										<template slot-scope="scope">
											<div>{{scope.row.is_tc==0?'否': '是'}}</div>
										</template>
									</el-table-column>
									<el-table-column label="是否为艺术类" min-width="150">
										<template slot-scope="scope">
											<div>{{scope.row.is_art==0?'否': '是'}}</div>
										</template>
									</el-table-column>
									<el-table-column label="备注" width="330">
										<template slot-scope="scope">
											<div>{{scope.row.sp_remark?scope.row.sp_remark: '--'}}</div>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="upgradeTotal" :page-size="20" @current-change="getSpecialListHandler" v-if="upgradeTotal > 0" :current-page.sync="currentUpgradePage">
								</el-pagination>
							</el-row>
						</div>
						<div class="school-detail-common school-detail-kx">
							<h3>招生快讯</h3>
							<div v-if="!searchSpecialStatus2 && !noSpecialRequestStatus2">
								<ContentLoader v-for="item in 20" :key="item" primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="50" width="1100" viewBox="0 0 1000 50">
									<rect x="0" y="10" width="170" height="25" />
									<rect x="1000" y="10" width="110" height="25" />
								</ContentLoader>
							</div>
							<div v-else>
								<div class="no-data-box" v-if="totalSpecialData == 0">
									<img src="../../assets/images/null.png" alt="没有数据">
									<p>暂无数据</p>
								</div>
								<el-row type="flex" justify="space-between" class="school-detail-zs" v-for="(item,index) in newsSpecialList" :key="index" @click.native="linkSpecialNewsHandler(item.id)" v-else>
									<el-col :span="22">{{item.title}}</el-col>
									<el-col :span="2">{{item.create_time.split(' ')[0]}}</el-col>
								</el-row>
								<el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="totalSpecialData"  :page-size="20" @current-change="getSpecialNewsHandler" v-if="totalSpecialData > 0" :current-page.sync="currentUpgradeNewsPage">
								</el-pagination>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="提前批详情" name="eight">
						<div class="school-detail-common school-detail-fs school-detail-ln">
							<el-row>
								<el-col :span="2">
									科目类型：
								</el-col>
								<el-col :span="2" class="header-link" @mouseenter.native="linkShowState3('true')" @mouseleave.native="linkShowState3('false')">
									<a>{{subjectDefault3.name}}<i class="el-icon-arrow-down el-icon--right" v-if="linkShow3=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="linkShow3=='true'"></i></a>
									<el-menu v-show="linkShow3=='true'">
										<li v-for="(item,index) in subjectList3" :key="index" @click="changeYearHandler3(index)">{{item.name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="2">
									年份：
								</el-col>
								<el-col :span="2" v-if="preDefault" class="header-link header-link-diff1" @mouseenter.native="yearLinkShowState2('true')" @mouseleave.native="yearLinkShowState2('false')">
									<a>{{preDefault.year}}<i class="el-icon-arrow-down el-icon--right" v-if="yearLinkShow2=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="yearLinkShow2=='true'"></i></a>
									<el-menu v-show="yearLinkShow2=='true'" class="header-link-menu">
										<li v-for="(item,index) in yearPreList" :key="index" @click="changePreYearHandler(index)">{{item}}</li>
									</el-menu>
								</el-col>
								<el-col :span="2" v-else class="header-link header-link-diff1">--</el-col>
								<!-- <el-col :span="2">
									批次类型：
								</el-col>
								<el-col :span="2" v-if="batchDefault2" class="header-link header-link-diff3" @mouseenter.native="batchLinkShowState2('true')" @mouseleave.native="batchLinkShowState2('false')">
									<a>{{batchDefault2.name}}<i class="el-icon-arrow-down el-icon--right" v-if="batchLinkShow2=='false'"></i><i class="el-icon-arrow-up el-icon--right" v-if="batchLinkShow2=='true'"></i></a>
									<el-menu v-show="batchLinkShow2=='true'" class="batch-list-menu batch-list-menu-diff">
										<li v-for="(item,index) in batchList2" :key="index" @click="changeBatchHandler2(index)">{{item.name}}</li>
									</el-menu>
								</el-col>
								<el-col :span="4" v-else class="header-link header-link-diff2">--</el-col> -->
							</el-row>
							<ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="200" width="1100" viewBox="0 0 1100 200" v-if="!searchSchoolStatus1 && !noRequestStatus1">
								<rect x="0" y="20" width="1100" height="180" />
							</ContentLoader>
							<el-row v-else>
								<el-table :data="preInfor" style="width: 100%" border :span-method="arraySpanMethod">
									</el-table-column>
									<el-table-column label="学校名称">
										<template slot-scope="scope">
											<div class="adv-title" style="font-size: 16px">{{scope.row.college_code?'[' + scope.row.college_code + ']':''}}{{scope.row.scl_name}}</div>
											{{scope.row.scl_remark}}
										</template>
									</el-table-column>
									<el-table-column label="招生类型" width="170">
										<template slot-scope="scope">
											<div class="adv-title">{{type_obj[scope.row.zslx]}}</div>
											计划招生总数：{{scope.row.scl_plan_num?scope.row.scl_plan_num:'-'}}<br>
											最低分：{{scope.row.scl_score_min?scope.row.scl_score_min:'-'}}<br>
											位次：{{scope.row.scl_section_min?scope.row.scl_section_min:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="专业">
										<template slot-scope="scope">
											<div class="adv-title">{{scope.row.plan_name}}</div>
											{{scope.row.plan_remark?scope.row.plan_remark:''}}{{!scope.row.plan_remark && scope.row.sp_length?'学制：' + scope.row.sp_length + '年':''}}{{!scope.row.plan_remark && scope.row.tuition?'学费：' + scope.row.tuition + '元/年':''}}
										</template>
									</el-table-column>
									<el-table-column label="计划招生" width="110">
										<template slot-scope="scope">
											{{scope.row.sp_num?scope.row.sp_num:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="最低分" width="94">
										<template slot-scope="scope">
											{{scope.row.sp_score_min?scope.row.sp_score_min:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="位次" width="80">
										<template slot-scope="scope">
											{{scope.row.sp_section_min?scope.row.sp_section_min:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="学制" width="80">
										<template slot-scope="scope">
											{{scope.row.sp_length?scope.row.sp_length:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="学费" width="80">
										<template slot-scope="scope">
											{{scope.row.tuition?scope.row.tuition:'-'}}
										</template>
									</el-table-column>
								</el-table>
								<!-- <el-pagination
									background
									layout="prev, pager, next, jumper"
									:total="preTotal" :page-size="20" @current-change="getPreSpecialHandler" v-if="planTotal > 0" :current-page.sync="currentPlanPage">
								</el-pagination> -->
							</el-row>
						</div>
					</el-tab-pane>
				</el-tabs>
			</template>
		</el-row>
		<el-dialog :title="majorDetailInfor.special_name" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-major" v-if="showMajorDetailStatus">
			<img src="../../assets/images/close.png" alt="关闭" @click="closeMajorDetailHandler()">
			<el-row class="dialog-major-tag" type="flex" justify="center">
				<span v-if="majorDetailInfor.special_type">{{majorDetailInfor.special_type == '1'?'本科':'专科'}}</span>
				<span v-if="majorDetailInfor.limit_year">{{majorDetailInfor.limit_year}}</span>
				<span v-if="majorDetailInfor.is_important == '1'">重点学科</span>
				<span v-if="majorDetailInfor.nation_feature == '1'">国家特色专业</span>
				<span v-if="majorDetailInfor.province_feature == '1'">省特色专业</span>
			</el-row>
			<GeminiScrollbar class="dialog-major-detail">
				<div v-html="majorDetailInfor.special_content"></div>
				<!-- <div v-else>暂无介绍</div> -->
			</GeminiScrollbar>
		</el-dialog>
		<FavDetail v-if="isFav" :favList="fav_data" :favInfo="fav_info" @update="updateFav"></FavDetail>
    </div>
</template>

<script>
import { addFav, delFav } from '@/api/user'
import { getSearchDic } from "@/api/zhiyuan"
import { getSchoolIntro, getSchoolSpecial, getPreBatch, getSchoolAdvance, getSchoolScoreLine,getSchoolSpecialDetail, getSchoolStuPlan, getSchoolSpecialLine, getNewsList, getSchoolView, getSingleSpecial,getSinglePlanSelect,getSinglePlan,getSingleLineSelect,getSingleLine,getSingleNews, getSpecialList, getSpecialNews } from '@/api/school'
import { mapState } from "vuex";
import { ContentLoader } from 'vue-content-loader'
import { decrypt } from '@/utils/auth'
import FavDetail from '@/components/FavDetail'
import { getBatch } from "@/api/home"
export default {
    components: {
        ContentLoader,
		FavDetail
    },
	data() {
		return {
			activeName:'first',
			linkShow: 'false',
			linkShow1: 'false',
			linkShow2 : 'false',
			linkShow3 : 'false',
			yearLinkShow: 'false',
			yearLinkShow1: 'false',
			yearLinkShow2: 'false',
			batchLinkShow: 'false',
			batchLinkShow1: 'false',
			// batchLinkShow2: 'false',
			showAllContent: false,
			schoolInfor: {},
			majorInfor: [],
			majorInforAll: [],
			nextImg: require('../../assets/images/jtxh.png'),
			prevImg: require('../../assets/images/jtsh.png'),
			activeImg: 0,
			// activeImg1: 0,
			activeImgSrc: "",
			imageList: [],
			scl_id: '',
			subjectList: [],
			subjectList1: [],
			subjectList2: [],
			subjectList3: [],
			yearPlanList: [],
			yearLineList: [],
			yearPreList: [],
			// newBatchList: [
			// 	{ local_batch_id: '14', name: '本科批' },
			// 	{ local_batch_id: '10', name: '专科批' }
			// ],
			// oldBatchList: [
			// 	{ local_batch_id: '7', name: '本科一批' },
			// 	{ local_batch_id: '8', name: '本科二批' },
			// 	{ local_batch_id: '10', name: '专科批' },
			// ],
			batchList: [],
			batchListObj: {
				'6':'本科提前批',
				'7':'本科一批',
				'8':'本科二批',
				'10':'专科批',
				'11':'专科提前批',
				'14': '本科批'
			},
			batchList1: [],
			planDefault: {},
			lineDefault: {},
			specialYearDefault: '',
			preDefault: {},
			subjectDefault: {},
			subjectDefault1: {},
			subjectDefault2: {},
			subjectDefault3: {},
			batchDefault: '',
			batchDefault1: '',
			// batchDefault2: '',
			planInfor: [],
			lineInfor: [],
			preInfor: [],
			scoreLineInfor: [],
			scoreLineInforArr: [],
			showImgList: [],
			lineTotal: 0,
			planTotal: 0,
			lineDesc: '',
			specialTotal: 0,
			upgradeTotal: 0,
			preTotal: 0,
			currentLinePage: 1,
			currentPlanPage: 1,
			currentSpecialPage: 1,
			currentSinglePlanPage: 1,
			currentSingleLinePage: 1,
			currentUpgradePage: 1,
			currentPrePage: 1,
			newsList: [],
			newsSingleList: [],
			newsSpecialList: [],
			showNoDataStatus: false,
			showSingleNoDataStatus: false,
			currentSinglePage: 1,
			currentUpgradeNewsPage: 1,
			currentPage: 1,
			totalSingleData: 0,
			totalSpecialData: 0,
			totalData: 0,
			baseUrl: 'https://gaokao.zmpajx.com/scl_pic',
			searchSchoolStatus1: false,
			searchSingleStatus1: false,
			searchSingleStatus2: false,
			searchSingleStatus3: false,
			searchSingleStatus4: false,
			searchSpecialStatus1: false,
			searchSpecialStatus2: false,
			noRequestStatus1: false,
			noRequestStatus2: false,
			noRequestStatus3: false,
			noSingleRequestStatus1: false,
			noSingleRequestStatus2: false,
			noSingleRequestStatus3: false,
			noSingleRequestStatus4: false,
			noSpecialRequestStatus1: false,
			noSpecialRequestStatus2: false,
			scrollTag: false,
			scrollTop: 0,
			isPk: false,
			showImage: false,
			singleList: [],
			singleSelect: {},
			singleSelect1: {},
			singleYearDefault: '',
			singleYearDefault1: '',
			singleSubjectDefault: '',
			singleSubjectDefault1: '',
			singleStudentDefault: '',
			singleStudentDefault1: '',
			singleYearLinkShow: 'false',
			singleYearLinkShow1: 'false',
			singleSubjectLinkShow: 'false',
			singleSubjectLinkShow1: 'false',
			singleStudentLinkShow: 'false',
			singleStudentLinkShow1: 'false',
			singleStudentList: [],
			singleStudentList1: [],
			singleSubjectList: [],
			singleSubjectList1: [],
			singlePlanInfor: [],
			singleLineInfor: [],
			singleLineTotal: 0,
			singlePlanTotal: 0,
			showMajorDetailStatus: false,
			majorDetailInfor: {},
			specialYearDefault: '',
			specialYearList: [],
			specialInfor: [],
			yearSpecialShow1: 'false',
			has_code: 0,
			has_code1: 0,
			fav_value: 0,
			fav_data: [],
			fav_info: {},
			scl_ids: [],
			scl_pos: 0,
			zslx_ids: [],
			zslx_pos: 0,
			type_obj: {},
			type_edu: {},
			//area: localStorage.getItem("area")
		}
	},
	filters: {
		dateHandler(date) {
			if(date) {
				return date.split(" ")[0] 
			}
		}
	},
	computed: {
		...mapState({
			token: state => state.user.token,
			requestCount: state => state.user.requestCount,
			compareSchoolList: state => state.user.compareSchoolList,
			provinceCode: state => state.user.provinceCode,
			function_code: state => state.user.function_code,
			isFav: state => state.user.isFav,
			isLogin: state => state.user.isLogin
		}),
	},
	watch: {
		token (newVal) {
            if(newVal != '') {
				this.getAreaHandler()
                this.$store.commit('user/ADDCOUNT', 0);
				this.activeName = 'third';
				this.linkToSchoolSpecialLine();
            }
		},
		// lineDefault: {
		// 	handler(newVal, oldVal) {
		// 		if(Number(newVal.year) < 2024) {
		// 			this.batchList1 = this.oldBatchList
		// 		} else {
		// 			this.batchList1 = this.newBatchList
		// 		}
		// 		this.batchDefault1 = this.batchList1[0]
		// 	},
		// 	deep: true
		// },
		// planDefault: {
		// 	handler(newVal, oldVal) {
		// 		if(Number(newVal.year) < 2024) {
		// 			this.batchList = this.oldBatchList
		// 		} else {
		// 			this.batchList = this.newBatchList
		// 		}
		// 		this.batchDefault = this.batchList[0]
		// 	},
		// 	deep: true
		// },
		requestCount (newVal) {
            if(newVal > 0) {
				this.searchSingleStatus2 = false;
				this.searchSingleStatus3 = false;
				this.searchSingleStatus4 = false;
				this.searchSchoolStatus1 = false;
				this.searchSingleStatus1 = false;
				this.searchSpecialStatus1 = false;
				this.searchSpecialStatus2 = false;
            } else {
                this.searchSchoolStatus1 = true;
				this.searchSingleStatus2 = true;
				this.searchSingleStatus3 = true;
				this.searchSingleStatus4 = true;
				this.searchSingleStatus1 = true;
				this.searchSpecialStatus1 = true;
				this.searchSpecialStatus2 = true;
            }
        },
		function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00024'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
			const tmp1 = this.function_code.filter(item => { return item.function_code === 'F00023'})
			if(tmp1.length > 0) {
                this.has_code1 = tmp[0].has_code
            }
		},
		compareSchoolList(newVal) {
			if(newVal.indexOf(this.scl_id) != -1) {
				this.isPk = true;
			} else {
				this.isPk = false;
			}
		},
		provinceCode(newVal) {
            if(newVal != '') {
				this.getAreaHandler();
				this.activeName = 'first';
				this.getSchoolIntroHandler();
				this.getSchoolSpecialHandler();
				this.getPreSpecialHandler();
				this.getNewsListHandler('1','6');
				this.getSchoolViewHandler();
            }
        },
	},
	beforeRouteLeave(to, from, next) {
		next()
		this.$store.commit("user/LOGINSTATUS",false)
	},
    created() {
		this.$store.commit('user/ADDCOUNT', 0);
		let scl_id = this.$route.query.scl_id;
		this.scl_id = scl_id;
		if(this.compareSchoolList.indexOf(scl_id) != -1) {
			this.isPk = true;
		}
        this.getSchoolIntroHandler();
		
		setTimeout(()=> {
			this.getPreBatchHandler();
			this.getSchoolSpecialHandler();
			this.getNewsListHandler('1','6');
			this.getSchoolViewHandler();
		}, 1000)
		
    },
	mounted() {
		window.addEventListener('scroll', this.getScroll, true);
		const tmp = this.function_code.filter(item => { return item.function_code === 'F00024'})
		if(tmp.length > 0) {
			this.has_code = tmp[0].has_code
		}
		const tmp1 = this.function_code.filter(item => { return item.function_code === 'F00023'})
		if(tmp1.length > 0) {
			this.has_code1 = tmp[0].has_code
		}
		this.getSearchDicHandler();
	},
	destroyed() {
        window.removeEventListener('scroll', this.getScroll, true)
    },
    methods: {
			getSearchDicHandler() {
            try {
                getSearchDic().then(res => {
                    if (res.status != 200 || !res) {
                        return
                    }
                    res.data.edu_type.map( item => {
                        this.type_edu[item.dic_code] = item.dic_value
                    })
                }).catch(error => {
                    console.log(error);
                })
            } catch (error) { console.log(error) }
        },
		getAreaHandler() {
			this.subjectList = []
			this.batchList = JSON.parse(sessionStorage.getItem('newBatch'))
			this.batchList1 = this.batchList;
			this.subjectList = JSON.parse(sessionStorage.getItem('newSubject'))
			this.changePro('plan')
			this.changePro('special')
			this.changePro('pre')
			// this.subjectList1 = [...this.subjectList]
			// this.subjectList2 = [...this.subjectList]
			// this.subjectList3 = [...this.subjectList]
			this.subjectDefault = this.subjectList[0]
			// this.subjectDefault1 = this.subjectList1[0]
			// this.subjectDefault2 = this.subjectList2[0]
			// this.subjectDefault3 = this.subjectList3[0]
			this.getSchoolScoreLineHandler('1');
        },
		getScroll(){
			let top = document.getElementById('app').scrollTop
			this.scrollTop = top;
			if (top > 420) {
				this.scrollTag = true;
			} else {
				this.scrollTag = false;
			}

        },
        linkShowState(linkShow) {
			this.linkShow = linkShow;
		},
        linkShowState1(linkShow1) {
			this.linkShow1 = linkShow1;
		},
        linkShowState2(linkShow2) {
			this.linkShow2 = linkShow2;
		},
		linkShowState3(linkShow3) {
			this.linkShow3 = linkShow3;
		},
        yearLinkShowState(yearLinkShow) {
			this.yearLinkShow = yearLinkShow;
		},
        yearLinkShowState1(yearLinkShow1) {
			this.yearLinkShow1 = yearLinkShow1;
		},
		yearLinkShowState2(yearLinkShow2) {
			this.yearLinkShow2 = yearLinkShow2;
		},
        batchLinkShowState(batchLinkShow) {
			this.batchLinkShow = batchLinkShow;
		},
        batchLinkShowState1(batchLinkShow1) {
			this.batchLinkShow1 = batchLinkShow1;
		},
		// batchLinkShowState2(batchLinkShow2) {
		// 	this.batchLinkShow2 = batchLinkShow2;
		// },
		singleYearLinkShowState(singleYearLinkShow) {
			this.singleYearLinkShow = singleYearLinkShow
		},
		singleYearLinkShowState1(singleYearLinkShow1) {
			this.singleYearLinkShow1 = singleYearLinkShow1
		},
		singleSubjectLinkShowState(singleSubjectLinkShow) {
			this.singleSubjectLinkShow = singleSubjectLinkShow
		},
		singleSubjectLinkShowState1(singleSubjectLinkShow1) {
			this.singleSubjectLinkShow1 = singleSubjectLinkShow1
		},
		singleStudentLinkShowState(singleStudentLinkShow) {
			this.singleStudentLinkShow = singleStudentLinkShow
		},
		singleStudentLinkShowState1(singleStudentLinkShow1) {
			this.singleStudentLinkShow1 = singleStudentLinkShow1
		},
		showAllhandler() {
			this.showAllContent = !this.showAllContent;
		},
		getPreBatchHandler() {
			getPreBatch().then(res => {
				// this.batchList2 = res.data.batch
				// this.batchDefault2 = this.batchList2[0]
				let yearList = [];
				res.data.year.map(item => {
					yearList.push(item.year)
				})
				res.data.zslx.map(item => {
                	this.type_obj[item.id] = item.name
                })
				// if(res.data.new_year) {
				// 	let year = res.data.new_year;
				// 	// let year = 2025;
				// 	let yearList = [];
				// 	for(let i= 0; i < 3; i++) {
				// 		let newYear =  year-i;
				// 		if(newYear != '2016') {
				// 			yearList.push(newYear);
				// 		} else {
				// 			break
				// 		}
				// 	}
					this.yearPreList = yearList;
					this.preDefault.year = this.yearPreList[0]
					this.getPreSpecialHandler();
				// }
			})
		},
		getSchoolIntroHandler() {
			getSchoolIntro(this.scl_id, this.provinceCode).then(res => {
				const data = res.data;
				this.schoolInfor = data.scl_intro;
				this.planDefault = data.plan_default ? data.plan_default: '';
				this.lineDefault = data.line_default ? data.line_default : '';
				this.specialYearDefault = data.transfer_year ? data.transfer_year : '';
				this.fav_data = data.fav_data
				const fav_tmp = this.fav_data.filter(val =>{ return val.fav === 1 })
				this.fav_value = parseFloat((fav_tmp.length / this.fav_data.length).toFixed(2))
				this.fav_value -= 0.01
				if(data.local_type_id) {
					const subject_tmp = this.subjectList.filter(val => { return val.local_type === data.local_type_id })
					this.subjectDefault1 = subject_tmp[0]
					this.subjectDefault2 = subject_tmp[0]
					this.subjectDefault = subject_tmp[0]
				}
				if(data.line_default) {
					let year1 = this.lineDefault.year;
					// let year1 = 2025;
					let yearList1 = [];
					for(let i= 0; i < 3; i++) {
						let newYear =  year1-i;
						if(newYear != '2016') {
							yearList1.push(newYear);
						} else {
							break
						}
					}
					this.yearLineList = yearList1;
				}
				if(data.plan_default) {
					let year = this.planDefault.year;
					// let year = 2026;
					let yearList = [];
					for(let i= 0; i < 3; i++) {
						let newYear =  year-i;
						if(newYear != '2016') {
							yearList.push(newYear);
						} else {
							break
						}
					}
					this.yearPlanList = yearList;
				}
				if(data.transfer_year) {
					let year = this.specialYearDefault;
					let yearList = [];
					for(let i= 0; i < 3; i++) {
						let newYear =  year-i;
						if(newYear != '2016') {
							yearList.push(newYear);
						} else {
							break
						}
					}
					this.specialYearList = yearList;
				}
				let school_type = '';
				let school_nature = '';
				let school_nature_type = '';
				if(data.scl_intro.scl_type == '5000') {
					school_type = '综合'
				} else if(data.scl_intro.scl_type == '5001') {
					school_type = '理工'
				} else if(data.scl_intro.scl_type == '5002') {
					school_type = '农林'
				} else if(data.scl_intro.scl_type == '5003') {
					school_type = '医药'
				} else if(data.scl_intro.scl_type == '5004') {
					school_type = '师范'
				} else if(data.scl_intro.scl_type == '5005') {
					school_type = '语言'
				} else if(data.scl_intro.scl_type == '5006') {
					school_type = '财经'
				} else if(data.scl_intro.scl_type == '5007') {
					school_type = '政法'
				} else if(data.scl_intro.scl_type == '5008') {
					school_type = '体育'
				} else if(data.scl_intro.scl_type == '5009') {
					school_type = '艺术'
				} else if(data.scl_intro.scl_type == '5010') {
					school_type = '民族'
				} else if(data.scl_intro.scl_type == '5011') {
					school_type = '军事'
				} else {
					school_type = '其他'
				}
				if(data.scl_intro.scl_nature == '36000') {
					school_nature = '公办'
				} else if(data.scl_intro.scl_nature == '36001') {
					school_nature = '民办'
				} else if(data.scl_intro.scl_nature == '36002') {
					school_nature = '中外合作办学'
				}
				// if(data.scl_intro.scl_nature_type == '6000') {
				// 	if(data.scl_intro.f211 == '1' || data.scl_intro.f985 == '1' || data.scl_intro.is_provincial == '1' || (data.scl_intro.dual_class != '38003' && data.scl_intro.dual_class)) {
				// 		school_nature_type = '本科'
				// 	} else {
				// 		school_nature_type = '普通本科'
				// 	}
				// } else if(data.scl_intro.scl_nature_type == '6001') {
				// 	 	if(data.scl_intro.is_doublehigh == '77') {
				// 			school_nature_type = '专科'
				// 		} else {
				// 			school_nature_type = '普通专科'
				// 		}
				// } else if(data.scl_intro.scl_nature_type == '6002') {
				// 	school_nature_type = '中外合作办学'
				// }
				school_nature_type = this.type_edu[data.scl_intro.scl_nature_type];
				this.schoolInfor = Object.assign({}, this.schoolInfor, {school_type: school_type,school_nature: school_nature,school_nature_type:school_nature_type,logo:'https://gaokao.zmpajx.com/pic/'+this.schoolInfor.scl_id+'.jpg'});
                this.getAreaHandler();
            })
		},
		getSchoolSpecialHandler() {
			getSchoolSpecial(this.scl_id).then(res => {
				let data = res.data;
				data = data.map(function(item, index, data) {
					const i = data.find(_item => item.subject_type_name === _item.subject_type_name);
					if(i !== item) {
						i.special_name.push(item.special_name);
						i.id.push(item.id);
						return undefined;
					} else {
						i.special_name = [i.special_name];
						i.id = [i.id];
						return i;
					}
				}).filter(item => item !== undefined);
				this.majorInfor = data.slice(0,6);
				this.majorInforAll = data;
			})
		},
		getPreSpecialHandler() {
			const params = {
				// local_batch_sub_id: this.batchDefault2.local_batch_sub_id,
				scl_id: this.scl_id,
				year: this.preDefault.year,
				local_type_id: this.subjectDefault3.local_type
			}
			this.scl_ids = []
            this.pos = 0
            this.zslx_ids = []
            this.zslx_pos = 0
			getSchoolAdvance(params).then(res => {
				if(res.data.length === 0) {
					return
				} 
				this.preInfor = res.data.data
				// const tmp = res.data[0]
				// const sep_tmp = {
				// 	sp_score_min: tmp.scl_section_min,
				// 	sp_num: tmp.scl_score_min,
				// 	plan_name: tmp.scl_name,
				// 	plan_code: `[${tmp.college_code}]${tmp.scl_name}`,
				// 	plan_remark: tmp.scl_plan_num,
				// 	scl_remark: tmp.scl_remark,
				// 	is_scl: true

				// }
				res.data.data.forEach((element, index) => {
                    if (index === 0) {
                        this.scl_ids.push(1)
                        this.pos = 0
                        this.zslx_ids.push(1)
                        this.zslx_pos = 0
                    } else {
                    	if (element.scl_id === res.data.data[index - 1].scl_id) {
                    		this.scl_ids[this.pos] += 1
                            this.scl_ids.push(0)
                        } else {
                            this.scl_ids.push(1)
                            this.pos = index
                        }
                        if ((element.scl_id + element.zslx) === res.data.data[index - 1].scl_id + res.data.data[index - 1].zslx) {
                    		this.zslx_ids[this.zslx_pos] += 1
                            this.zslx_ids.push(0)
                        } else {
                            this.zslx_ids.push(1)
                            this.zslx_pos = index
                        }
                    }
                })
				// this.preInfor.unshift(sep_tmp)
			})
		},
		arraySpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
                let _row = this.scl_ids[rowIndex]
                let _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            } else if (columnIndex === 1) {
                let _row = this.zslx_ids[rowIndex]
                let _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            }
		},
		// tableRowClassName({row, rowIndex}) {
		// 	if (rowIndex === 0) {
		// 		return 'scl-row';
		// 	}
		// 	return '';
		// },
		showAllMajorHandler() {
			this.$store.commit('user/ADDCOUNT', 0);
			this.activeName = 'second';
			if(this.scrollTop > 420) {
				window.scrollTo(0, 460);
			} else {
				this.scrollTag = false;
			}
		},
		getSchoolScoreLineHandler(page) {
			if(page > 1) {
				this.noRequestStatus1 = true;
				this.noRequestStatus2 = true;
				this.noRequestStatus3 = false;
			}
			let { local_type } = this.subjectDefault;
			getSchoolScoreLine(local_type, this.scl_id, this.provinceCode, page).then(res => {
				const decryptData = JSON.parse(decrypt(res.data));
				const data = decryptData.data;
				if(data.length > 0){
					this.lineTotal = decryptData.count;
					this.scoreLineInfor = data;
					if(data.length > 6) {
						this.scoreLineInforArr = data.slice(0,6);
					} else {
						this.scoreLineInforArr = data.slice(0,data.length);
					}
					this.$forceUpdate();
				}
			})
		},
		beforeLeave(e) {
			if(e == 'third') {
				var p = new Promise((resolve, reject) => {
					if(!this.token) {
						this.$store.commit("user/LOGINSTATUS",true);
						reject()
					} else {
						resolve()
					}
				})
				return p
			}
		},
		handleClick(e) {
			this.$store.commit('user/ADDCOUNT', 0);
			let name = e.name;
			if(this.scrollTop > 420) {
				window.scrollTo(0, 460);
			} else {
				this.scrollTag = false;
			}
			if(name == 'third') {
				if(!this.token) {
					return
				}
				this.linkToSchoolSpecialLine();
			} else if(name == 'fourth') {
				this.linkToSchoolStuPlan();
			} else if(name == 'first') {
				this.scoreLineInfor = [];
				this.subjectDefault = this.subjectList[0];
				this.currentLinePage = 1;
				this.lineTotal = 0;
				this.getSchoolScoreLineHandler('1');
				this.newsList = [];
				this.totalData = 0;
				this.currentPage = 1;
				this.getNewsListHandler('1','6');
				this.getSchoolViewHandler();
			} else if(name == 'fifth') {
				this.newsList = [];
				this.totalData = 0;
				this.currentPage = 1;
				this.getNewsListHandler('1','20');
			} else if(name == 'sexth') {
				this.singleList = [];
				this.singleYearDefault = '';
				this.singleYearDefault1 = '';
				this.singleSubjectDefault = '';
				this.singleSubjectDefault1 = '';
				this.singleStudentDefault = '';
				this.singleStudentDefault1 = '';
				this.singleStudentList = [];
				this.singleStudentList1 = [];
				this.singleSubjectList = [];
				this.singleSubjectList1 = [];
				this.getSingleSpecialHandler();
				this.getSinglePlanSelectHandler();
				this.getSingleLineSelectHandler();
				this.getSingleNewsHandler('1');
			} else if(name == 'seventh') {
				// this.specialYearDefault = this.specialYearList[0];
				this.getSpecialListHandler('1');
				this.getSpecialNewsHandler('1');
			}
		},
		linkToSchoolSpecialLine() {
			// let year1 = this.lineDefault.year;
			// let yearList1 = [];
			// for(let i= 0; i < 3; i++) {
			// 	let newYear =  year1-i;
			// 	if(newYear != '2016') {
			// 		yearList1.push(newYear);
			// 	} else {
			// 		break
			// 	}
			// }
			this.batchDefault1 = (this.batchList1.filter(item => item.local_batch_id == this.lineDefault.local_batch_id))[0];
			if(!this.batchDefault1) {
				return
			}
			// this.yearLineList = yearList1;
			this.lineDefault.year = this.yearLineList[0];
			this.lineInfor = [];
			this.scoreLineInfor = [];
			this.lineTotal = 0;
			this.specialTotal = 0;
			this.currentLinePage = 1;
			this.currentSpecialPage = 1;
			this.getSchoolScoreLineHandler('1');
			this.getSchoolSpecialLineHandler('1');
		},
		linkToSchoolStuPlan() {
			// let year = this.planDefault.year;
			// let yearList = [];
			// for(let i= 0; i < 3; i++) {
			// 	let newYear =  year-i;
			// 	if(newYear != '2016') {
			// 		yearList.push(newYear);
			// 	} else {
			// 		break
			// 	}
			// }
			this.batchDefault = (this.batchList.filter(item => item.local_batch_id == this.planDefault.local_batch_id))[0];
			if(!this.batchDefault) {
				return
			}
			// this.yearPlanList = yearList;
			this.planDefault.year = this.yearPlanList[0];
			this.planInfor = [];
			this.planTotal = 0;
			this.currentPlanPage = 1;
			this.getSchoolStuPlanHandler('1');
		},
		showAllScoreHandler() {
			if(!this.token) {
				return
			}
			this.$store.commit('user/ADDCOUNT', 0);
			if(this.scrollTop > 420) {
				window.scrollTo(0, 460);
			} else {
				this.scrollTag = false;
			}
			this.activeName = 'third';
			this.noRequestStatus1 = false;
			this.noRequestStatus2 = false;
			this.noRequestStatus3 = false;
			this.planInfor = [];
			this.lineInfor = [];
			this.scoreLineInfor = [];
			this.lineTotal = 0;
			this.planTotal = 0;
			this.specialTotal = 0;
			this.currentLinePage = 1;
			this.currentPlanPage = 1;
			this.currentSpecialPage = 1;
			this.linkToSchoolSpecialLine();
		},
		changeYearHandler(index) {
			this.subjectDefault = this.subjectList[index];
			this.resetSchoolScoreLineHandler();
		},
		changeYearHandler1(index) {
			this.subjectDefault1 = this.subjectList1[index];
			this.resetSchoolStuPlanHandler();
		},
		changeYearHandler2(index) {
			this.subjectDefault2 = this.subjectList2[index];
			this.resetSchoolSpecialLineHandler();
		},
		changeYearHandler3(index) {
			this.subjectDefault3 = this.subjectList3[index];
			this.resetPreSpecialHandler();
		},
		changePlanYearHandler(index) {
			this.planDefault.year = this.yearPlanList[index];
			// this.batchDefault = this.batchList[0]
			this.changePro('plan')
			setTimeout(() => {
				this.resetSchoolStuPlanHandler();
			}, 300);
		},
		changeLineYearHandler(index) {
			this.lineDefault.year = this.yearLineList[index];
			// this.batchDefault1 = this.batchList1[0]
			this.changePro('special')
			setTimeout(() => {
				this.resetSchoolSpecialLineHandler();
			}, 300);
		},
		changePreYearHandler(index) {
			this.preDefault.year = this.yearPreList[index];
			this.changePro('pre')
			setTimeout(() => {
				this.resetPreSpecialHandler();
			}, 300);
		},
        changePro(type) {
			const param = {
                area: this.provinceCode,
                scl_id: this.scl_id,
                year: ''
            }
			if(type === 'plan'){
				param.year = this.planDefault.year
			} else if(type === 'special'){
				param.year = this.lineDefault.year
			} else if(type === 'pre'){
				param.year = this.preDefault.year
			}
            getBatch(param).then(res => {
				if(type === 'plan'){
					this.batchList = res.data.local_batch_id
					this.subjectList1 = res.data.local_type_id
					this.batchDefault = this.batchList[0]
					this.subjectDefault1 = this.subjectList1[0]
				} else if(type === 'special'){
					param.year = this.lineDefault.year
					this.batchList1 = res.data.local_batch_id
					this.subjectList2 = res.data.local_type_id
					this.batchDefault1 = this.batchList1[0]
					this.subjectDefault2 = this.subjectList2[0]
				} else if(type === 'pre'){
					param.year = this.preDefault.year
					this.subjectList3 = res.data.local_type_id
					this.subjectDefault3 = this.subjectList3[0]
				}
            })
        },
		changeBatchHandler(index) {
			this.batchDefault = this.batchList[index] ? this.batchList[index] : '';
			this.resetSchoolStuPlanHandler();
		},
		changeBatchHandler1(index) {
			this.batchDefault1 = this.batchList1[index] ? this.batchList1[index] : '';
			this.resetSchoolSpecialLineHandler();
		},
		// changeBatchHandler2(index) {
		// 	this.batchDefault2 = this.batchList2[index] ? this.batchList2[index] : '';
		// 	this.resetPreSpecialHandler();
		// },
		getSchoolStuPlanHandler(page) {
			if(page > 1) {
				this.noRequestStatus2 = true;
				this.noRequestStatus3 = true;
				this.noRequestStatus1 = false;
			}
			let { year } = this.planDefault;
			let local_batch  = this.batchDefault.local_batch_id;
			let { local_type } = this.subjectDefault1;
			getSchoolStuPlan(year, local_batch, local_type, this.scl_id, localStorage.getItem("area"), page).then(res => {
				const decryptData = JSON.parse(decrypt(res.data));
				const data = decryptData.data;
				// const data = res.data.data;
				this.planInfor = data;
				this.planTotal = decryptData.count;
			})
		},
		getSchoolSpecialLineHandler(page) {
			if(this.has_code == 0) {
				return
			}
			if(page > 1) {
				this.noRequestStatus1 = true;
				this.noRequestStatus3 = true;
				this.noRequestStatus2 = false;
			}
			let { year } = this.lineDefault;
			let local_batch = this.batchDefault1.local_batch_id;
			let { local_type } = this.subjectDefault2;
			try {
				getSchoolSpecialLine(year,local_batch,local_type,this.scl_id,localStorage.getItem("area"),page).then(res => {
					if(res.status == '200') {
						const decryptData = JSON.parse(decrypt(res.data));
						this.lineDesc = decryptData.tip;
						this.specialTotal = decryptData.count;
						const data = decryptData.data;
						// const data = res.data.data;
						if(data.length > 0) {
							let lineInfor = [];
							// data.forEach(item => {
							// 	let obj = {};
							// 	let batch = '';
							// 	obj = item;
							// 	if(item.local_batch_id == '6') {
							// 		batch = '本科提前批'
							// 	} else if(item.local_batch_id == '7') {
							// 		batch = '本科一批'
							// 	} else if(item.local_batch_id == '8') {
							// 		batch = '本科二批'
							// 	} else if(item.local_batch_id == '9') {
							// 		batch = '本科三批'
							// 	} else if(item.local_batch_id == '12') {
							// 		batch = '国家专项计划本科批'
							// 	} else if(item.local_batch_id == '11') {
							// 		batch = '专科提前批'
							// 	} else if(item.local_batch_id == '10') {
							// 		batch = '专科批'
							// 	} else if(item.local_batch_id == '13') {
							// 		batch = '地方专项计划本科批'
							// 	}
							// 	obj.batch = batch;
							// 	lineInfor.push(obj);
							// });
							this.lineInfor = data;
						}
					} else {
						this.$message({
			                message: res.message,
			                type: 'warning',
			                duration: 5 * 1000
			            })
					}
				})
			} catch (error) {
				console.log(error);
			}
		},
		hoverPrevImgHandler() {
			this.prevImg = require('../../assets/images/jtsl.png');
		},
		prevImgHandler() {
			this.prevImg = require('../../assets/images/jtsh.png');
		},
		hoverNextImgHandler() {
			this.nextImg = require('../../assets/images/jtxl.png');
		},
		nextImgHandler() {
			this.nextImg = require('../../assets/images/jtxh.png');
		},
		changeImgSrcHandler(index) {
			this.activeImg = index;
			// this.activeImg1 = this.activeImg % 3;
			this.activeImgSrc = this.imageList[this.activeImg];
		},
		clickPrevImgHandler() {
			this.nextImg = require('../../assets/images/jtxh.png');
			if(this.activeImg == 0) {
				return
			}
			if(this.activeImg % 3 == 0) {
				this.showImgList = this.imageList.slice(this.activeImg-3,this.activeImg);
			}
			this.activeImg--;
			this.activeImg1 = this.activeImg % 3;
			this.activeImgSrc = this.imageList[this.activeImg];
		},
		clickNextImgHandler() {
			this.prevImg = require('../../assets/images/jtsh.png');
			if(this.activeImg >= (this.imageList-1)) {
				return
			}
			this.activeImg++;
			this.activeImg1 = this.activeImg % 3;
			this.activeImgSrc = this.imageList[this.activeImg];
			if(this.activeImg % 3 == 0) {
				this.showImgList = this.imageList.slice(this.activeImg,this.activeImg+3);
			}
		},
		getNewsListHandler(page,size) {
			if(!size) {
				size = '20';
			}
			getNewsList(page,size,this.scl_id).then(res => {
				if(res.data.total == 0) {
					this.showNoDataStatus = true;
					return
				}
				this.showNoDataStatus = false; 
				this.totalData = res.data.total;
				this.newsList = res.data.list;
			})
		},
		showAllNewsHandler() {
			if(this.scrollTop > 420) {
				window.scrollTo(0, 460);
			} else {
				this.scrollTag = false;
			}
			this.$store.commit('user/ADDCOUNT', 0);
			this.activeName = 'fifth';
			this.newsList = [];
			this.totalData = 0;
			this.currentPage = 1;
			this.getNewsListHandler('1','20');
		},
		linkNewsHandler(id) {
			this.$router.push({
				path: '/schoolNewsDetail',
				query: {
					scl_id: this.scl_id,
					id: id,
				}
			})
		},
		linkSingleNewsHandler(id) {
			this.$router.push({
				path: '/singleNewsDetail',
				query: {
					scl_id: this.scl_id,
					id: id,
				}
			})
		},
		linkSingleDetailHandler(id) {
			this.$router.push({
				path: '/singleDetail',
				query: {
					scl_id: this.scl_id,
					id: id,
				}
			})
		},
		getSchoolViewHandler() {
			getSchoolView(this.scl_id).then(res => {
				if(res.data.length > 0) {
					this.imageList = [...res.data];
					// this.showImgList = this.imageList.slice(0,3);
					this.showImgList = this.imageList;
					this.activeImgSrc = this.imageList[this.activeImg];
				}
			}).catch(error => {console.log(error)})
		},
		addCompare() {
            let compareSchoolList = this.$store.state.user.compareSchoolList;
            if(compareSchoolList.length == 4) {
                this.$message({
                    message: '最多可添加4所院校',
                    type: 'warning'
                })
                return
            }
			this.showImage = true;
            compareSchoolList.push(this.scl_id);
			this.isPk = true;
        },
        removeCompare() {
            let compareSchoolList = this.$store.state.user.compareSchoolList;
            let removeIndex = compareSchoolList.indexOf(this.scl_id);
            compareSchoolList.splice(removeIndex,1);
			this.isPk = false;
			this.showImage = false;
        },
		beforeEnter (el) {
            let schoolImg = this.$refs.schoolImg;
            let rect = schoolImg.getBoundingClientRect();
            el.style.transform = 'translate(10px,10px)';
            el.style.position = "absolute";
            el.style.left = (rect.x) +'px';
            el.style.top = (rect.y) +'px';
            el.style.zIndex = '9999';
        },
        // 进入中
        enter (el, done) {
            // 需要调用元素的offset操作,才有过渡的效果,否则会马上实现过渡
            el.offsetWidth;
            let x = document.documentElement.clientWidth;
            let y = document.documentElement.clientHeight;
            let schoolImg = this.$refs.schoolImg;
            let rect = schoolImg.getBoundingClientRect();
            el.style.position = "fixed";
            el.style.right = "16px";
            el.style.bottom = "332px";
            el.style.transform = 'translate('+(x-130-rect.x)+'px,'+(y-500-rect.y)+'px)';
            el.style.transition = "all 0.5s cubic-bezier(.42, 0, .58, 1)";
            done()
        },
        // 进入后
        afterEnter () {
            this.showImage = !this.showImage
        },
		nofindImg() {
			this.schoolInfor.logo = require("../../assets/images/scl_default.png");
		},
		getSingleSpecialHandler() {
			getSingleSpecial(this.scl_id).then(res => {
				if(res.data) {
					this.singleList = res.data;
				} else {
					this.noSingleRequestStatus1 = true;
				}
			})
		},
		getSinglePlanSelectHandler() {
			getSinglePlanSelect(this.scl_id,localStorage.getItem("area")).then(res => {
				this.singleSelect = res.data;
				this.singleYearDefault = res.data.year[0];
				let singleStudentObj = res.data.student[0];
				let singleSubjectObj = res.data.single[0];
				for (const key in singleStudentObj) {
					if (Object.hasOwnProperty.call(singleStudentObj, key)) {
						let obj = {}
						obj.single_id = key;
						obj.single_name = singleStudentObj[key];
						this.singleStudentDefault = obj;
					}
				}
				for (const key in singleSubjectObj) {
					if (Object.hasOwnProperty.call(singleSubjectObj, key)) {
						let obj = {}
						obj.single_id = key;
						obj.single_name = singleSubjectObj[key];
						this.singleSubjectDefault = obj;
					}
				}
				let studentList = []
				for (const key in res.data.student) {
					if (Object.hasOwnProperty.call(res.data.student, key)) {
						let studentObj = res.data.student[key]
						for (const key1 in studentObj) {
							if (Object.hasOwnProperty.call(studentObj, key1)) {
								let obj = {}
								obj.single_id = key1;
								obj.single_name = studentObj[key1];
								studentList.push(obj);
								this.singleStudentList = studentList;
							}
						}
					}
				}
				let singleList1 = []
				for (const key in res.data.single) {
					if (Object.hasOwnProperty.call(res.data.single, key)) {
						let singleObj = res.data.single[key]
						for (const key1 in singleObj) {
							if (Object.hasOwnProperty.call(singleObj, key1)) {
								let obj = {}
								obj.single_id = key1;
								obj.single_name = singleObj[key1];
								singleList1.push(obj);
								this.singleSubjectList = singleList1;
							}
						}
					}
				}
				this.getSinglePlanHandler('1');
			})
		},
		getSingleLineSelectHandler() {
			getSingleLineSelect(this.scl_id,localStorage.getItem("area")).then(res => {
				this.singleSelect1 = res.data;
				this.singleYearDefault1 = res.data.year[0];
				let singleStudentObj = res.data.student[0];
				let singleSubjectObj = res.data.single[0];
				for (const key in singleStudentObj) {
					if (Object.hasOwnProperty.call(singleStudentObj, key)) {
						let obj = {}
						obj.single_id = key;
						obj.single_name = singleStudentObj[key];
						this.singleStudentDefault1 = obj;
					}
				}
				for (const key in singleSubjectObj) {
					if (Object.hasOwnProperty.call(singleSubjectObj, key)) {
						let obj = {}
						obj.single_id = key;
						obj.single_name = singleSubjectObj[key];
						this.singleSubjectDefault1 = obj;
					}
				}
				let studentList = []
				for (const key in res.data.student) {
					if (Object.hasOwnProperty.call(res.data.student, key)) {
						let studentObj = res.data.student[key]
						for (const key1 in studentObj) {
							if (Object.hasOwnProperty.call(studentObj, key1)) {
								let obj = {}
								obj.single_id = key1;
								obj.single_name = studentObj[key1];
								studentList.push(obj);
								this.singleStudentList1 = studentList;
							}
						}
					}
				}
				let singleList1 = []
				for (const key in res.data.single) {
					if (Object.hasOwnProperty.call(res.data.single, key)) {
						let singleObj = res.data.single[key]
						for (const key1 in singleObj) {
							if (Object.hasOwnProperty.call(singleObj, key1)) {
								let obj = {}
								obj.single_id = key1;
								obj.single_name = singleObj[key1];
								singleList1.push(obj);
								this.singleSubjectList1 = singleList1;
							}
						}
					}
				}
				this.getSingleLineHandler('1');
			})
		},
		getSinglePlanHandler(page) {
			if(page > 1) {
				this.noSingleRequestStatus2 = false;
				this.noSingleRequestStatus3 = true;
				this.noSingleRequestStatus1 = true;
				this.noSingleRequestStatus4 = true;
			}
			let year = this.singleYearDefault;
			let student = this.singleStudentDefault.single_id;
			let single = this.singleSubjectDefault.single_id;
			getSinglePlan(this.scl_id,localStorage.getItem('area'),page,year,single,student).then(res => {
				const data = res.data.data;
				this.singlePlanInfor = data;
				this.singlePlanTotal = res.data.total;
			})
		},
		getSingleLineHandler(page) {
			if(page > 1) {
				this.noSingleRequestStatus3 = false;
				this.noSingleRequestStatus2 = true;
				this.noSingleRequestStatus1 = true;
				this.noSingleRequestStatus4 = true;
			}
			let year = this.singleYearDefault1;
			let student = this.singleStudentDefault1.single_id;
			let single = this.singleSubjectDefault1.single_id;
			getSingleLine(this.scl_id,localStorage.getItem('area'),page,year,single,student).then(res => {
				const data = res.data.data;
				this.singleLineInfor = data;
				this.singleLineTotal = res.data.total;
			})
		},
		getSingleNewsHandler(page) {
			if(page > 1) {
				this.noSingleRequestStatus2 = true;
				this.noSingleRequestStatus3 = true;
				this.noSingleRequestStatus1 = true;
				this.noSingleRequestStatus4 = false;
			}
			getSingleNews(this.scl_id,localStorage.getItem("area"),page).then(res => {
				// if(res.data.total == 0) {
				// 	// this.showSingleNoDataStatus = true;
				// 	return
				// }
				// this.showSingleNoDataStatus = false, 
				this.totalSingleData = res.data.total;
				this.newsSingleList = res.data.data;
			})
		},
		changeSingleYearHandler(index) {
			this.singleYearDefault = this.singleSelect.year[index];
			this.resetSinglePlanHandler();
		},
		changeSingleYearHandler1(index) {
			this.singleYearDefault1 = this.singleSelect1.year[index];
			this.resetSingleLineHandler();
		},
		changeSingleSubjectHandler(index) {
			this.singleSubjectDefault = this.singleSubjectList[index];
			this.resetSinglePlanHandler();
		},
		changeSingleSubjectHandler1(index) {
			this.singleSubjectDefault1 = this.singleSubjectList1[index];
			this.resetSingleLineHandler();
		},
		changeSingleStudentHandler(index) {
			this.singleStudentDefault = this.singleStudentList[index];
			this.resetSinglePlanHandler();
		},
		changeSingleStudentHandler1(index) {
			this.singleStudentDefault1 = this.singleStudentList1[index];
			this.resetSingleLineHandler();
		},
		resetSinglePlanHandler() {
			this.noSingleRequestStatus2 = false;
			this.noSingleRequestStatus3 = true;
			this.noSingleRequestStatus4 = true;
			this.singlePlanInfor = [];
			this.singlePlanTotal = 0;
			this.currentSinglePlanPage = 1;
			this.getSinglePlanHandler('1');
		},
		resetSingleLineHandler() {
			this.noSingleRequestStatus3 = false;
			this.noSingleRequestStatus2 = true;
			this.noSingleRequestStatus4 = true;
			this.singleLineInfor = [];
			this.singleLineTotal = 0;
			this.currentSingleLinePage = 1;
			this.getSingleLineHandler('1');
		},
		resetSchoolScoreLineHandler() {
			this.scoreLineInfor = [];
			this.currentLinePage = 1;
			this.lineTotal = 0;
			this.noRequestStatus1 = true;
			this.noRequestStatus2 = true;
			this.noRequestStatus3 = false;
			this.getSchoolScoreLineHandler('1');
		},
		resetSchoolStuPlanHandler() {
			this.planInfor = [];
			this.planTotal = 0;
			this.currentPlanPage = 1;
			this.noRequestStatus2 = true;
			this.noRequestStatus3 = true;
			this.noRequestStatus1 = true;
			this.getSchoolStuPlanHandler('1');
		},
		resetSchoolSpecialLineHandler() {
			this.lineInfor = [];
			this.lineTotal = 0;
			this.currentLinePage = 1;
			this.noRequestStatus1 = true;
			this.noRequestStatus3 = true;
			this.noRequestStatus2 = true;
			this.getSchoolSpecialLineHandler('1');
		},
		resetPreSpecialHandler() {
			this.preInfor = [];
			this.preTotal = 0;
			this.currentPrePage = 1;
			this.noRequestStatus1 = true;
			this.noRequestStatus3 = true;
			this.noRequestStatus2 = true;
			this.getPreSpecialHandler('1');
		},
		showMajorDetailHandler(row,index) {
			this.showMajorDetailStatus = true;
			this.majorDetailInfor = {};
			getSchoolSpecialDetail(row.id[index]).then(res => {
				this.majorDetailInfor = res.data;
			})
		},
		closeMajorDetailHandler() {
			this.showMajorDetailStatus = false;
		},
		specialYearLinkShowState1(yearSpecialShow1) {
			this.yearSpecialShow1 = yearSpecialShow1
		},
		changeSpecialYearHandler(index) {
			this.specialYearDefault = this.specialYearList[index];
			this.resetSpecialListHandler();
		},
		resetSpecialListHandler() {
			this.noSpecialRequestStatus1 = false;
			this.noSpecialRequestStatus2 = true;
			this.specialInfor = [];
			this.upgradeTotal = 0;
			this.currentUpgradePage = 1;
			this.getSpecialListHandler('1');
		},
		getSpecialListHandler(page) {
			if(page > 1) {
				this.noSpecialRequestStatus1 = false;
				this.noSpecialRequestStatus2 = true;
			}
			let year = this.specialYearDefault;
			getSpecialList(this.scl_id,localStorage.getItem('area'),page,year).then(res => {
				this.upgradeTotal = res.data.total;
				this.specialInfor = res.data.data;
			})
		},
		getSpecialNewsHandler(page) {
			if(page > 1) {
				this.noSpecialRequestStatus2 = false;
				this.noSpecialRequestStatus1 = true;
			}
			getSpecialNews(this.scl_id,localStorage.getItem("area"),page).then(res => {
				this.totalSpecialData = res.data.total;
				this.newsSpecialList = res.data.data;
			})
		},
		linkSpecialNewsHandler(id) {
			this.$router.push({
				path: '/specialNewsDetail',
				query: {
					scl_id: this.scl_id,
					id: id,
				}
			})
		},
		// 心仪详情
		favDetail() {
			if(this.fav_data.length <= 1) {
				const data = this.fav_data[0]
				const param = {
					stu_id: data.stu_id,
					fav_type: 1,
					data: this.schoolInfor.scl_id
				}
				if(data.fav === 0) {
					addFav(param).then(res => {
						this.fav_data[0].fav = 1
						this.updateFav(this.fav_data)
						this.$forceUpdate()
					})
				} else {
					delFav(param).then(res => {
						this.fav_data[0].fav = 0
						this.updateFav(this.fav_data)
						this.$forceUpdate()
					})
				}
				return
			}
			this.fav_info = {
				name: this.schoolInfor.scl_name,
				id: this.schoolInfor.scl_id,
				fav_type: 1
			}
			this.$store.commit('user/SHOWISFAV', true)
		},
		// 心仪更新
		updateFav(data) {
			this.fav_data = [...data]
			const fav_tmp = this.fav_data.filter(val =>{ return val.fav === 1 })
			this.fav_value = parseFloat((fav_tmp.length / this.fav_data.length).toFixed(2))
			this.fav_value -= 0.01
		}
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
	.school-detail-bg {
		@include gwidth;
		height: 232px;
		background: url('../../assets/images/schoolDetail.jpg') no-repeat;
		background-size: 100% 100%;
		margin-top: 24px;
		padding: 32px 40px 0 40px;
		.el-col-18 {
			margin-top: 10px;
		}
	}
	.el-col-3 {
		width: 14%;
	}
	.school-logo {
		width: 120px;
		height: 120px;
		border-radius: 50%;
		background: rgba(255,255,255,0.1);
		img {
			width: 100%;
			height: 100%;
			border-radius: 50%;
		}
		.active-img-inner {
			width: 120px;
			height: 120px;
		}
	}
	.zytb-school-name {
		font-size: 32px;
		font-weight: 600;
		color: #fff;
		margin-bottom: 14px;
	}
	.zytb-school-tag span {
		display: inline-block;
		padding: 3px 10px;
		font-size: 14px;
		color: #ffffff;
		height: 22px;
		background: rgba(255,255,255,0.20);
		border-radius: 4px;
		line-height: 22px;
		margin-right: 8px;
		margin-top: 10px;
	}
	.zytb-school-name img {
		width: 16px;
		height: 16px;
		position: relative;
		top: -2px;
		left: 20px;
	}
	.zytb-school-name span {
		color: #fff;
		font-size: 12px;
		font-weight: 400;
		position: relative;
		top: -6px;
		left: 22px;
	}
	.school-detail-gw {
		color: #332e2c;
		font-size: 14px;
		font-weight: 400;
		margin-bottom: 20px;
		.school-detail-gw-title {
			font-weight: 600;
			margin-bottom: 8px;
		}
		a {
			color: #332e2c;
			font-size: 14px;
			font-weight: 400;
			margin-bottom: 20px;
			text-decoration: none;
		}
		.school-detail-gw-title-diff:hover {
			color: $common-color;
		}
		img {
			width: 16px;
			height: 16px;
			position: relative;
			top: 2.5px;
			margin-right: 8px;
		}
	}
	.school-detail-nav {
		@include gwidth;
	}
	.school-detail-common {
		background: #ffffff;
		border-radius: 10px;
		box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10);
		padding: 24px;
		margin-bottom: 16px;
		min-height: 230px;
		position: relative;
		h3 {
			font-size: 20px;
			font-weight: 600;
			color: #2c2e33;
			border-left: 3px solid $common-color;
			padding-left: 8px;
			margin-top: 0;
            margin-bottom: 24px;
		}
		video {
			width: 360px;
			height: 202px;
			background: #e2e2e2;
		}
		.school-detail-all {
			width: 100%;
			height: 48px;
			background: linear-gradient(180deg,rgba(255,207,187,0.04), rgba(255,183,152,0.20) 99%);
			backdrop-filter: blur(5px);
			text-align: center;
			font-size: 14px;
			font-weight: 400;
			color: #66605e;
			line-height: 48px;
			position: absolute;
			bottom: 2px;
			span {
				display: inline-block;
				width: 90px;
				cursor: pointer;
				margin-right: 0;
			}
			i {
				margin-left: 4px;
				color: #c4c7cc!important;
			}
		}
		.school-detail-all span:hover {
			color: $common-color!important;
			.el-icon-arrow-right {
				color: $common-color!important;
			}
		} 
	}
	.school-detail-js {
		font-size: 16px!important;
		color: #2c2e33!important;
		text-align: left;
		line-height: 24px;
		max-height: 206px;
		overflow: hidden;
	}
	.school-detail-js p {
		font-size: 16px!important;
		color: #2c2e33!important;
	}
	.school-detail-js-more {
		max-height: 10000px;
	}
	.choice-box {
		font-size: 14px;
		margin-top: 16px;
		color: $common-color;
		cursor: pointer;
		float: right;
		i {
			margin-left: 5px;
		}
	}
	.school-detail-xx {
		.el-col-24:not(:last-child) {
			margin-bottom: 20px;
		}
		.el-col-12 {
			text-align: center;
			margin-top: 9px;
		}
		h3 {
			margin-bottom: 32px;
		}
		.grid-content {
			border-radius: 8px;
			box-shadow: 0px 0px 7px 0px rgba(44,46,51,0.10); 
			height: 140px;
			padding: 16px 24px;
			box-sizing: border-box;
		}
		.school-detail-blue {
			background: url('../../assets/images/bs.png');
			background-size:100% 100%;
		}
		.school-detail-green {
			background: url('../../assets/images/ss.png');
			background-size:100% 100%;
		}
		.school-detail-ju {
			background: url('../../assets/images/sys.png');
			background-size:100% 100%;
		}
		.school-detail-red {
			background: url('../../assets/images/xk.png');
			background-size:100% 100%;
		}
		.school-detail-xl {
			font-size: 0;
			font-size: 18px;
			color: #fff;
			font-weight: 600;
		}
		.school-detail-sl {
			color: #fff;
			font-size: 14px;
			margin-top: 10px;
			.school-count-zero {
				position: relative;
				top: 4px;
			}
			.el-col-24 {
				margin-top: 10px;
			}
			.school-detail-count {
				color: #ffffff;
				font-size: 40px;
				font-weight: 600;
			}
			.school-detail-yj {
				color: #fff;
				margin-top: 5px;
			}
		}
	}
	.school-detail-zy,.school-detail-fs,.school-detail-kx {
		button {
			width: 95px;
			height: 30px;
			line-height: 30px;
			border: 1px solid #ccc6c4!important;
			border-radius: 8px;
			color: #999390!important;
			padding: 0 10px;
			font-size: 14px;
			i {
				margin-left: 4px;
				color: #c4c7cc!important;
			}
		}
		button:hover {
			border: 1px solid $common-color!important;
			color: $common-color!important;
			.el-icon-arrow-right {
				color: $common-color!important;
			}
		} 
		span {
			margin-right: 24px;
			font-size: 16px;
			font-weight: 400;
		}
	}
	.school-detail-zs:not(:last-child) {
        margin-bottom: 27px;
	}
    .school-detail-zs {
		cursor: pointer;
        .el-col-18,.el-col-22 {
            font-size: 16px;
            color: #2c2e33;
			@include gnowrap;
			padding-right: 20px;
        }
		.el-col-22 {
			font-weight: 600;
			margin-bottom: -3px;
		}
		.el-col-2 {
			margin-bottom: -3px;
		}
		.el-col-18:hover,.el-col-22:hover {
			color: $common-color;
		}
        .el-col-6,.el-col-2 {
            font-size: 14px;
            color: #909399;
			text-align: right;
        }
    }
    .school-detail-fg {
		// padding-bottom: 0;
        .el-col-18 {
            width: 72.8%;
            .active-img-box {
                width: 521px;
				height: 393px;
                background-color: #e2e2e2;
                border-radius: 10px;
				background-size: cover;
				background-repeat: no-repeat;
				background-position:center;
            }
        }
		.el-col-6::-webkit-scrollbar {
			display: none;
		}
        .el-col-6 {
            text-align: center;
            position: relative;
			height: 393px;
			overflow-y: scroll;
			width: 27.2%;
			position: relative;
			left: 4px;
            // top: -20px;
            .school-small-img {
                display: block;
                width: 195px;
				height: 147px;
                background-color: #e2e2e2;
                border-radius: 10px;
                margin-bottom: 16px;
            }
            .school-detail-jts,.school-detail-jtx {
                width: 40px;
                height: 16px;
                background-color: transparent;
                border-radius: 0px;
                position: relative;
				margin-bottom: 16px;
            }
        }
    }
    .school-detail-fs {
        .el-col-2 {
            font-size: 14px;
            color: #909399;
            position: relative;
        }
        a {
            position: relative;
            color: $common-color;
        }
        .header-link {
            margin-left: -27px;
            cursor: pointer;
            margin-right: 160px;
			width: auto !important;
			max-width: 6%;
        }
        .header-link-diff1 {
            margin-left: -52px;
        }
        .header-link-diff2 {
            margin-left: -52px;
			position: relative;
			max-width: 15%;
			width: auto !important;
			font-size: 14px;
        }
		.header-link-diff3 {
			max-width: 16%;
		}
        .el-menu {
            min-width: 80px!important;
            width: auto!important;
            background: #ffffff;
            border-radius: 6px;
            box-shadow: 0px 1px 6px 0px rgba(51,55,61,0.20); 
            padding: 12px;
            box-sizing: border-box;
            position: absolute;
            left: -11%;
            margin-top: 10px;
            z-index: 999;
            -webkit-transition: -webkit-transform 0.1s
            cubic-bezier(0.165, 0.84, 0.44, 1);
            transition: transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);
            text-align: center;
            li {
                color: #5e6166;
                font-size: 14px;
                height: 28px;
                line-height: 28px;
            }
			li:hover {
				color: $common-color;
			}
        }
		.batch-list-menu {
			width: 160px!important;
		}
		.batch-list-menu-diff {
			width: 220px!important;
		}
        .header-link-menu {
            left: -17%;
        }
    }
	.active-img {
		border: 2px solid $common-color;
	}
	.school-detail-common-diff1 h3 {
		margin-bottom: 12px;
	}
	.no-data-box {
        position: relative;
        top: 90px;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        img {
            width: 110px;
            height: 110px;
        }
        p {
            font-size: 16px;
            text-align: center;
            color: #abaeb3;
            margin-left: -14px;
        }
    }
	.school-compare,.school-compare-diff {
		width: 136px;
		height: 50px;
		background: rgba(255,255,255,0.20)!important;
		border: 1px solid #ffffff;
		border-radius: 8px;
		color: #ffffff;
		font-size: 18px;
		text-align: center;
		padding: 0;
		margin-top: 34px;
		background-color: #fff;
		float: right;
		margin-left: 16px;
		img {
			width: 12px;
			height: 12px;
		}
		.fav-img1 {
			width: 18px;
			height: 18px;
			position: relative;
			top: 2px;
		}
	}
	.school-compare-diff {
		color: $common-color!important;
		background: #ffffff!important;
		border: none!important;
	}
	.single-special-table {
		// border-top: 1px solid #e1e4eb;
		// border-left: 1px solid #e1e4eb;
		font-size: 16px;
		color: #2c2e33;
		text-align: left;
		.el-col-6 {
			height: 46px;
			line-height: 46px;
			padding-left: 12px;
			border-right: 1px solid #e1e4eb;
			border-bottom: 1px solid #e1e4eb;
			overflow: hidden;
			white-space:nowrap;
			-o-text-overflow:ellipsis;
			text-overflow:ellipsis;
		}
		.el-col-6:nth-child(1) {
			border-top: 1px solid #e1e4eb;
		}
		.el-col-6:nth-child(4n-3) {
			border-left: 1px solid #e1e4eb;
		}
		.el-col-6:nth-child(2) {
			border-top: 1px solid #e1e4eb;
		}
		.el-col-6:nth-child(3) {
			border-top: 1px solid #e1e4eb;
		}
		.el-col-6:nth-child(4) {
			border-top: 1px solid #e1e4eb;
		}
		.el-col-6:hover {
			color: $common-color!important;
			cursor: pointer;
		}
	}
	.dialog-major {
		img {
			width: 24px;
			height: 24px;
			position: absolute;
			right: 40px;
			top: 40px;
			z-index: 999;
		}
		.dialog-major-tag {
			font-size: 28px;
			font-weight: 600;
			color: #2c2e33;
			line-height: 40px;
			span {
				display: inline-block;
				// min-width: 48px;
				height: 26px;
				padding: 0 10px;
				background: rgba(255,101,36,0.80);
				border-radius: 4px;
				font-size: 14px;
				font-weight: 400;
				color: #ffffff;
				line-height: 26px;
				text-align: center;
			}
			span:not(:last-child) {
				margin-right:8px;
			}	
		}
		.dialog-major-detail {
			font-size: 16px;
			font-weight: 400;
			text-align: left;
			color: #5e6166;
			line-height: 22px;
			margin-top: 24px;
			height: 454px;
		}
	}
	::v-deep {
		.el-rate__icon {
			font-size: 24px;
			position: relative;
			top: -2px;
			margin-right: 2px;
		}
		.el-rate__decimal {
			color: #ff6524!important;
			font-size: 24px;
		}
		.school-compare-diff span {
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.adv-title {
			color: #2c2e33;
			font-weight: 700;
		}
		.el-table{
            th {
                padding: 8px 12px;
            }
            td {
                padding: 8px 0 8px 12px;
            }
        }
		// .scl-row {
		// 	background: rgba(240,242,245,0.5)!important;
		// 	&:hover > td {
		// 		background: rgba(240,242,245,0.1)!important;
		// 	}
		// }
	} 
</style>